{
  "+1 day": "+1 dag",
  "1 hour": "1 uur",
  "1 hour 15 minutes": "1 uur en 15 minuten",
  "1 hour 30 minutes": "1 uur en 30 minuten",
  "1 hour 45 minutes": "1 uur en 45 minuten",
  "15 minutes": "15 minuten",
  "2 hours": "2 uur",
  "30 minutes": "30 minuten",
  "45 minutes": "45 minuten",
  "A change date is required": "Een wijzigingsdatum is verplicht",
  "A day holds at most 10 periods": "Een dag heeft maximaal 10 periodes",
  "A new code is on its way.": "Er is een nieuwe code onderweg.",
  "A pattern of 2–56 days that repeats, e.g. 2 early, 2 night, 4 off": "Een patroon van 2–56 dagen dat zich herhaalt, bijv. 2 vroeg, 2 nacht, 4 vrij",
  "Absence": "Verzuim",
  "Absence contact person": "Verzuimcontactpersoon",
  "Absence workflow package": "Verzuimworkflowpakket",
  "Absences registered for this person appear here.": "Verzuim dat voor deze persoon is geregistreerd verschijnt hier.",
  "Account frozen": "Account geblokkeerd",
  "Account manager": "Accountmanager",
  "Action list": "Actielijst",
  "Action plan": "Plan van Aanpak",
  "Action plan review": "Evaluatie Plan van Aanpak",
  "Actions": "Acties",
  "Actions for this version": "Acties voor deze versie",
  "Actions panel": "Actiepaneel",
  "Activation links expire for your security. Ask your administrator to send a new invitation.": "Activatielinks verlopen om veiligheidsredenen. Vraag uw beheerder om een nieuwe uitnodiging te sturen.",
  "Active": "Actief",
  "Active filters": "Actieve filters",
  "Add": "Toevoegen",
  "Add a date": "Datum toevoegen",
  "Add a period or choose Off": "Voeg een periode toe of kies Vrij",
  "Add period": "Periode toevoegen",
  "Addition": "Toevoeging",
  "Address": "Adres",
  "Address copied": "Adres gekopieerd",
  "Afternoon": "Middag",
  "AGB code": "AGB-code",
  "Agenda": "Agenda",
  "All cases": "Alle dossiers",
  "Amend": "Wijzigen",
  "An end date is required": "Een einddatum is verplicht",
  "Analysis": "Analyse",
  "Apply": "Toepassen",
  "Are you still there?": "Bent u er nog?",
  "Assigned to me": "Aan mij toegewezen",
  "Awaiting signature": "Wacht op ondertekening",
  "Back to list": "Terug naar de lijst",
  "Back to rotation": "Terug naar rotatie",
  "Back to sign in": "Terug naar inloggen",
  "Back to workbench": "Terug naar werkbank",
  "Based on your gender.": "Op basis van uw geslacht.",
  "Break (min)": "Pauze (min)",
  "Business phone": "Telefoon zakelijk",
  "Calendar apps using the current link stop updating until you subscribe with the new one.": "Agenda-apps met de huidige link worden pas weer bijgewerkt als u zich met de nieuwe link abonneert.",
  "Calendar link regenerated. Subscribe again with the new link.": "Agendalink opnieuw gegenereerd. Abonneer u opnieuw met de nieuwe link.",
  "Calendar subscription": "Agenda-abonnement",
  "Can't compare with the contract hours: the period is incomplete": "Niet te vergelijken met contracturen: de periode is onvolledig",
  "Can't scan the code?": "Kunt u de code niet scannen?",
  "Cancel": "Annuleren",
  "Cancelled": "Geannuleerd",
  "Care team": "Behandelteam",
  "Case manager": "Casemanager",
  "Case not found": "Dossier niet gevonden",
  "Cases assigned to you appear here.": "Dossiers die aan jou zijn toegewezen verschijnen hier.",
  "Cause category": "Oorzaakcategorie",
  "Certainty": "Zekerheid",
  "Certificate": "Certificaat",
  "Certificate actions for {role}": "Acties voor het certificaat van {role}",
  "Certificate removed": "Certificaat verwijderd",
  "Certificate uploaded": "Certificaat geüpload",
  "Chained": "Ketenverzuim",
  "Change date": "Wijzigingsdatum",
  "Change email": "E-mailadres wijzigen",
  "Change password": "Wachtwoord wijzigen",
  "Change photo": "Foto wijzigen",
  "Change theme": "Thema wijzigen",
  "Changed on this date only": "Afwijking op deze datum",
  "Changes on single dates are kept.": "Afwijkingen op losse datums blijven behouden.",
  "Choose a JPEG, PNG or GIF image under 5 MB.": "Kies een JPEG-, PNG- of GIF-afbeelding van maximaal 5 MB.",
  "Choose a JPEG, PNG or WebP image under 5 MB.": "Kies een JPEG-, PNG- of WebP-afbeelding van maximaal 5 MB.",
  "Choose a client first": "Kies eerst een klant",
  "Choose a gender": "Kies een geslacht",
  "Choose your password": "Kies uw wachtwoord",
  "Choose a password you are not using now": "Kies een wachtwoord dat u nu niet gebruikt",
  "Choose a PDF or DOCX under 5 MB.": "Kies een PDF- of DOCX-bestand van maximaal 5 MB.",
  "Choose a start date": "Kies een startdatum",
  "Choose an employer first": "Kies eerst een werkgever",
  "Choose an employment to copy from": "Kies een dienstverband om van te kopiëren",
  "Choose the date day 1 falls on": "Kies de datum waarop dag 1 valt",
  "Choose the date the roster is filled in up to": "Kies tot welke datum het rooster is ingevuld",
  "City": "Plaats",
  "Clear": "Wissen",
  "Clear filters": "Filters wissen",
  "Clear search": "Zoekopdracht wissen",
  "Client": "Klant",
  "Client not found": "Klant niet gevonden",
  "Client type": "Klanttype",
  "Clients": "Klanten",
  "Clients you have access to appear here.": "Klanten waartoe u toegang heeft, verschijnen hier.",
  "Close": "Sluiten",
  "Closed": "Gesloten",
  "Collapse sidebar": "Zijbalk inklappen",
  "Complete the form to see the preview": "Vul het formulier aan om het voorbeeld te zien",
  "Completed": "Afgerond",
  "Completed late": "Te laat afgerond",
  "Completed on time": "Op tijd afgerond",
  "Confirm new password": "Bevestig nieuw wachtwoord",
  "Confirm your new password": "Bevestig uw nieuwe wachtwoord",
  "Confirm your password": "Bevestig uw wachtwoord",
  "Conflict": "Conflict",
  "Contact": "Contact",
  "Contact information": "Contactgegevens",
  "Contact number": "Contactnummer",
  "Contract": "Contract",
  "Contract package": "Contractpakket",
  "Contract type": "Contractvorm",
  "Copied": "Gekopieerd",
  "Copy": "Kopiëren",
  "Copy a work schedule": "Een werkrooster kopiëren",
  "Copy address": "Adres kopiëren",
  "Copy from another employment": "Kopiëren van een ander dienstverband",
  "Copy key": "Sleutel kopiëren",
  "Copy link": "Link kopiëren",
  "Correct": "Corrigeren",
  "Correct work schedule": "Werkrooster corrigeren",
  "Could not discard the draft. Try again.": "Verwijderen van het concept is mislukt. Probeer het opnieuw.",
  "Could not load this schedule": "Dit rooster kon niet worden geladen",
  "Could not save to file. Try again.": "Opslaan in dossier is mislukt. Probeer het opnieuw.",
  "Could not start the amendment. Try again.": "Het wijzigen kon niet worden gestart. Probeer het opnieuw.",
  "Countries could not be loaded.": "Landen konden niet worden geladen.",
  "Country": "Land",
  "Create schedule": "Rooster aanmaken",
  "Current": "Huidig",
  "Current absence": "Huidig verzuim",
  "Current email": "Huidig e-mailadres",
  "Current medical opinion": "Actueel oordeel bedrijfsarts",
  "Current password": "Huidig wachtwoord",
  "Dark": "Donker",
  "Date of birth": "Geboortedatum",
  "Day 1 falls on": "Dag 1 valt op",
  "Day 1 of the rotation falls on this date": "Dag 1 van de rotatie valt op deze datum",
  "Day {n}": "Dag {n}",
  "Delete": "Verwijderen",
  "Delete the version starting {date}?": "De versie die begint op {date} verwijderen?",
  "Delete version": "Versie verwijderen",
  "Department": "Afdeling",
  "Department code": "Afdelingscode",
  "Department name": "Afdelingsnaam",
  "Department not found": "Afdeling niet gevonden",
  "Departments": "Afdelingen",
  "Departments you have access to appear here.": "Afdelingen waartoe u toegang heeft, verschijnen hier.",
  "Details": "Gegevens",
  "Details, contacts and contract appear here.": "Gegevens, contactpersonen en contract verschijnen hier.",
  "Details, contacts and division appear here.": "Gegevens, contactpersonen en divisie verschijnen hier.",
  "Details, contacts and employer appear here.": "Gegevens, contactpersonen en werkgever verschijnen hier.",
  "Details, contacts and sector appear here.": "Gegevens, contactpersonen en sector verschijnen hier.",
  "Diagnosis category": "Diagnosecategorie",
  "Discard": "Verwerpen",
  "Discard changes?": "Wijzigingen verwerpen?",
  "Discard draft": "Concept verwijderen",
  "Discard this draft?": "Dit concept verwijderen?",
  "Discard your changes?": "Wijzigingen verwerpen?",
  "Disease code": "Ziektecode",
  "Division": "Divisie",
  "Division code": "Divisiecode",
  "Division name": "Divisienaam",
  "Division not found": "Divisie niet gevonden",
  "Divisions": "Divisies",
  "Divisions you have access to appear here.": "Divisies waartoe u toegang heeft, verschijnen hier.",
  "Documents": "Documenten",
  "Documents filed for this person appear here.": "Documenten die voor deze persoon zijn vastgelegd verschijnen hier.",
  "Dossiers": "Dossiers",
  "Draft": "Concept",
  "Due within 7 days": "Deadline binnen 7 dagen",
  "Earlier": "Eerder",
  "Earlier messages didn’t load.": "Eerdere berichten zijn niet geladen.",
  "Early": "Vroeg",
  "Email": "E-mail",
  "Email is required": "E-mailadres is verplicht",
  "Employability": "Belastbaarheid",
  "Employability profile": "Inzetbaarheidsprofiel",
  "Employee": "Werknemer",
  "Employees": "Medewerkers",
  "Employer": "Werkgever",
  "Employer not found": "Werkgever niet gevonden",
  "Employers": "Werkgevers",
  "Employers you have access to appear here.": "Werkgevers waartoe u toegang heeft, verschijnen hier.",
  "Employments": "Dienstverbanden",
  "Employments registered for this person appear here.": "Dienstverbanden die voor deze persoon zijn geregistreerd verschijnen hier.",
  "End": "Eind",
  "Enter a length from 2 to 56 days": "Vul een lengte in van 2 tot 56 dagen",
  "Enter a new password": "Voer een nieuw wachtwoord in",
  "Enter a time like 08:00": "Vul een tijd in zoals 08:00",
  "Enter a valid email address": "Voer een geldig e-mailadres in",
  "Enter both ends of the range": "Vul beide kanten van het bereik in",
  "Enter hours between 0 and 24, like 7,5 or 7:30": "Vul uren in tussen 0 en 24, zoals 7,5 of 7:30",
  "Enter the 6-digit code we sent to {email}.": "Voer de 6-cijferige code in die we naar {email} hebben gestuurd.",
  "Enter the break in whole minutes": "Vul de pauze in hele minuten in",
  "Enter the six-digit code": "Voer de zescijferige code in",
  "Enter the six-digit code from your authenticator app": "Voer de zescijferige code uit uw authenticator-app in",
  "Enter the six-digit code from your authenticator app.": "Voer de zescijferige code uit uw authenticator-app in.",
  "Enter this key into your authenticator app or password manager:": "Voer deze sleutel in uw authenticator-app of wachtwoordmanager in:",
  "Enter your credentials to continue.": "Voer uw gegevens in om door te gaan.",
  "Enter your current password": "Voer uw huidige wachtwoord in",
  "Enter your last name": "Voer uw achternaam in",
  "Events recorded for this person appear here.": "Gebeurtenissen die voor deze persoon zijn vastgelegd verschijnen hier.",
  "Everyone in your scope, with or without an open case.": "Iedereen binnen uw bereik, met of zonder open dossier.",
  "Exception": "Uitzondering",
  "Expand sidebar": "Zijbalk uitklappen",
  "Expires": "Verloopt",
  "Female": "Vrouw",
  "Fill the roster in up to a date on or after its start": "Vul het rooster in tot een datum op of na de start",
  "Filled in up to": "Ingevuld tot en met",
  "Filters": "Filters",
  "Final evaluation": "Eindevaluatie",
  "First name": "Voornaam",
  "First-year evaluation": "Eerstejaarsevaluatie",
  "Fix the errors to update the preview": "Herstel de fouten om het voorbeeld bij te werken",
  "Fixed week": "Vaste week",
  "Focus mode": "Focusmodus",
  "From": "Van",
  "From the fixed week": "Uit de vaste week",
  "From the rotation (day {day})": "Uit de rotatie (dag {day})",
  "From {date}: unknown": "Vanaf {date}: onbekend",
  "Gender": "Geslacht",
  "General": "Algemeen",
  "General information": "Algemene gegevens",
  "Go to dashboard": "Naar het dashboard",
  "HSE contact person": "KAM-contactpersoon",
  "Hide actions": "Acties verbergen",
  "Hide list": "Lijst verbergen",
  "Hours": "Uren",
  "House number": "Huisnummer",
  "How long you can be inactive before you are signed out automatically.": "Hoe lang u inactief kunt zijn voordat u automatisch wordt uitgelogd.",
  "Idle timeout": "Time-out bij inactiviteit",
  "Idle timeout saved": "Time-out opgeslagen",
  "If an account exists with that email address, you will receive a password reset link shortly.": "Als er een account bestaat met dat e-mailadres, ontvangt u binnenkort een link om uw wachtwoord opnieuw in te stellen.",
  "Include a lowercase letter": "Gebruik een kleine letter",
  "Include a number": "Gebruik een cijfer",
  "Include a symbol": "Gebruik een symbool",
  "Include an uppercase letter": "Gebruik een hoofdletter",
  "Incomplete": "Onvolledig",
  "Initials": "Initialen",
  "Issued": "Uitgegeven",
  "Issuing authority": "Uitgevende instantie",
  "It becomes part of the medical file. You can amend it later; this version stays readable.": "Ze wordt onderdeel van het medisch dossier. U kunt haar later wijzigen; deze versie blijft leesbaar.",
  "It may have been removed, or you may not have access to it.": "Mogelijk is deze verwijderd, of heeft u er geen toegang toe.",
  "Job description": "Functieomschrijving",
  "Keep editing": "Verder bewerken",
  "Keep the label under 50 characters": "Houd het label onder de 50 tekens",
  "Keep this page open until the application starts.": "Houd deze pagina open totdat de applicatie start.",
  "Label": "Label",
  "Labour expert assessment": "Arbeidsdeskundig onderzoek",
  "Last day of absence": "Laatste verzuimdag",
  "Last name": "Achternaam",
  "Late": "Laat",
  "Length in days": "Lengte in dagen",
  "License number": "Registratienummer",
  "Light": "Licht",
  "Load earlier": "Eerdere berichten laden",
  "Load more": "Meer laden",
  "Loading…": "Laden…",
  "Log out": "Uitloggen",
  "Looking up address…": "Adres opzoeken…",
  "Main contact person": "Hoofdcontactpersoon",
  "Male": "Man",
  "Manual": "Handmatig",
  "Medical file": "Medisch dossier",
  "Middle name": "Tweede voornaam",
  "Migrated": "Overgezet",
  "Milestone": "Mijlpaal",
  "Mobile number": "Mobiel nummer",
  "Mobile phone": "Mobiel",
  "Month total": "Maandtotaal",
  "More actions": "Meer acties",
  "More conversations didn’t load.": "Meer gesprekken zijn niet geladen.",
  "Morning": "Ochtend",
  "My caseload": "Mijn caseload",
  "My work": "Mijn werk",
  "NCVB category": "NCVB-categorie",
  "Name": "Naam",
  "Needs review": "Controleren",
  "New absence percentage": "Nieuw verzuimpercentage",
  "New email": "Nieuw e-mailadres",
  "New items appear here as deadlines approach.": "Nieuwe items verschijnen hier zodra een deadline nadert.",
  "New password": "Nieuw wachtwoord",
  "New schedule from…": "Nieuw rooster vanaf…",
  "New work schedule": "Nieuw werkrooster",
  "Next": "Volgende",
  "Next month": "Volgende maand",
  "Next obligation": "Volgende verplichting",
  "Night": "Nacht",
  "No open case": "Geen lopend dossier",
  "No open dossier": "Geen dossier",
  "No persons in your scope": "Geen personen binnen uw bereik",
  "No roles assigned yet": "Nog geen rollen toegewezen",
  "No schedule applies to these dates any more.": "Voor deze datums geldt dan geen rooster meer.",
  "No WVP workflow": "Geen WVP-workflow",
  "No WVP workflow assigned": "Geen WVP-workflow toegewezen",
  "No absences recorded": "Geen verzuim geregistreerd",
  "No care team assigned": "Geen behandelteam toegewezen",
  "No cases yet": "Nog geen dossiers",
  "No clients yet": "Nog geen klanten",
  "No clinical details recorded for the current absence.": "Geen klinische gegevens vastgelegd voor het huidige verzuim.",
  "No consultation notes yet": "Nog geen spreekuurnotities",
  "No current work schedule": "Geen actueel werkrooster",
  "No departments yet": "Nog geen afdelingen",
  "No divisions yet": "Nog geen divisies",
  "No documents yet": "Nog geen documenten",
  "Persons": "Personen",
  "Search by name or email…": "Zoek op naam of e-mail…",
  "Sex": "Geslacht",
  "Showing documents named “{name}”": "Documenten met de naam “{name}”",
  "Show all": "Alles tonen",
  "Medical documents": "Medische documenten",
  "No medical documents": "Geen medische documenten",
  "Medical documents filed for this person appear here.": "Medische documenten van deze persoon verschijnen hier.",
  "No employers yet": "Nog geen werkgevers",
  "No employments recorded": "Geen dienstverbanden geregistreerd",
  "No open obligation": "Geen openstaande verplichting",
  "No results": "Geen resultaten",
  "No results found.": "Geen resultaten gevonden.",
  "No work schedule": "Geen werkrooster",
  "No work schedule yet": "Nog geen werkrooster",
  "Not applicable": "Niet van toepassing",
  "Not assessed": "Niet beoordeeld",
  "Not available yet": "Nog niet beschikbaar",
  "Not monitored": "Niet gemonitord",
  "Not visible to the employer or to a process casemanager": "Niet zichtbaar voor de werkgever of een procescasemanager",
  "Not verified": "Niet geverifieerd",
  "Notes": "Notities",
  "Notes written during a consultation appear here.": "Notities die tijdens een spreekuur zijn geschreven verschijnen hier.",
  "Nothing has happened yet": "Er is nog niets gebeurd",
  "Nothing is open": "Er staat niets open",
  "Nothing matches these filters.": "Niets komt overeen met deze filters.",
  "Nothing matches your search.": "Niets komt overeen met uw zoekopdracht.",
  "Notifications": "Meldingen",
  "OHP": "OHP",
  "Occupational physician": "Bedrijfsarts",
  "Off": "Vrij",
  "Ongoing": "Lopend",
  "Only repeating schedules can be copied": "Alleen herhalende roosters kunnen worden gekopieerd",
  "Open": "Open",
  "Open in authenticator app": "Openen in authenticator-app",
  "Open user menu": "Gebruikersmenu openen",
  "Opening the ORL application…": "De ORL-applicatie wordt geopend…",
  "Options could not be loaded.": "Opties konden niet worden geladen.",
  "Organisation": "Organisatie",
  "Other devices are signed out when you change it.": "Andere apparaten worden uitgelogd wanneer u het wijzigt.",
  "Outside the employment": "Buiten het dienstverband",
  "Overdue": "Te laat",
  "Overview": "Overzicht",
  "POB": "POB",
  "Page not found": "Pagina niet gevonden",
  "Pages": "Pagina's",
  "Part-time": "Deeltijd",
  "Partial recovery": "Gedeeltelijk hersteld",
  "Password changed. Other devices have been signed out.": "Wachtwoord gewijzigd. Andere apparaten zijn uitgelogd.",
  "Password is required": "Wachtwoord is verplicht",
  "Passwords do not match": "Wachtwoorden komen niet overeen",
  "People": "Personen",
  "Period": "Periode",
  "Period {n}": "Periode {n}",
  "Photo removed": "Foto verwijderd",
  "Photo updated": "Foto bijgewerkt",
  "Pick something you have not used before.": "Kies iets dat u niet eerder heeft gebruikt.",
  "Pick the right entry": "Kies de juiste periode",
  "Poortwachter milestones": "Poortwachter-mijlpalen",
  "Postal address": "Postadres",
  "Postal code": "Postcode",
  "Powered by": "Mogelijk gemaakt door",
  "Prefix": "Tussenvoegsel",
  "Recent": "Recent",
  "Search is unavailable right now": "Zoeken is nu niet beschikbaar",
  "Searching…": "Zoeken…",
  "Untitled": "Zonder titel",
  "present": "heden",
  "Preview of this version": "Voorbeeld van deze versie",
  "Previous": "Vorige",
  "Previous month": "Vorige maand",
  "Problem analysis": "Probleemanalyse",
  "Professional": "Professional",
  "Professional Portal": "Professionalportaal",
  "Profile": "Profiel",
  "Profile saved": "Profiel opgeslagen",
  "QR code for setting up two-factor authentication": "QR-code voor het instellen van tweefactorauthenticatie",
  "Qualifications": "Kwalificaties",
  "Quick actions": "Snelle acties",
  "Reason for the correction": "Reden van de correctie",
  "Recovered": "Hersteld",
  "Reference": "Naslag",
  "Regenerate": "Opnieuw genereren",
  "Regenerate calendar link?": "Agendalink opnieuw genereren?",
  "Regenerate link": "Link opnieuw genereren",
  "Regenerating…": "Bezig met genereren…",
  "Register": "Melden",
  "Register partial recovery": "Gedeeltelijk herstel melden",
  "Register recovery": "Herstel melden",
  "Registering…": "Bezig met melden…",
  "Registration number": "Registratienummer",
  "Advice": "Advies",
  "Released advice": "Vrijgegeven advies",
  "Released to the employer": "Vrijgegeven aan de werkgever",
  "Released to the employee": "Vrijgegeven aan de werknemer",
  "Released to the employer and the employee": "Vrijgegeven aan de werkgever en de werknemer",
  "Reload": "Herladen",
  "Remove": "Verwijderen",
  "Remove certificate?": "Certificaat verwijderen?",
  "Remove date": "Datum verwijderen",
  "Remove days": "Dagen verwijderen",
  "Remove days {from} to {to}?": "Dagen {from} tot en met {to} verwijderen?",
  "Remove filter {label}": "Filter {label} verwijderen",
  "Remove period": "Periode verwijderen",
  "Remove photo?": "Foto verwijderen?",
  "Remove signature?": "Handtekening verwijderen?",
  "Replace": "Vervangen",
  "Report partial": "Gedeeltelijk melden",
  "Report recovery": "Herstel melden",
  "Report the date the percentage changed and what it changed to.": "Meld de datum waarop het percentage wijzigde en waarnaar.",
  "Report the last day of this absence.": "Meld de laatste verzuimdag.",
  "Reported": "Gemeld",
  "Resend code": "Code opnieuw versturen",
  "Resend in {seconds}s": "Opnieuw versturen over {seconds}s",
  "Reset your password": "Wachtwoord opnieuw instellen",
  "Resize actions panel": "Breedte actiepaneel aanpassen",
  "Retry": "Opnieuw proberen",
  "Role": "Rol",
  "Roles your administrator assigns to you appear here.": "Rollen die uw beheerder aan u toewijst, verschijnen hier.",
  "Roster": "Rooster",
  "Rotation": "Rotatie",
  "Rotation of {days} days": "Rotatie van {days} dagen",
  "Rows per page": "Rijen per pagina",
  "Salutation": "Aanhef",
  "Save": "Opslaan",
  "Save new password": "Nieuw wachtwoord opslaan",
  "Save this note to the file?": "Deze notitie opslaan in het dossier?",
  "Save to file": "Opslaan in dossier",
  "Saved to file {time}": "Opgeslagen in dossier {time}",
  "Saving…": "Bezig met opslaan…",
  "Say why you are correcting this version": "Geef aan waarom u deze versie corrigeert",
  "Scan this code with your authenticator app, then enter the six-digit code it shows.": "Scan deze code met uw authenticator-app en voer daarna de zescijferige code in die wordt getoond.",
  "Scheduled {scheduled}h a week on average, contract {expected}h a week": "Gepland gem. {scheduled}u per week, contract {expected}u per week",
  "Search": "Zoeken",
  "Search cases…": "Zoek dossiers…",
  "Search clients…": "Zoek klanten…",
  "Search departments…": "Zoek afdelingen…",
  "Search divisions…": "Zoek divisies…",
  "Search employers…": "Zoek werkgevers…",
  "Search…": "Zoeken…",
  "Second track start": "Start spoor 2",
  "Sector": "Sector",
  "Select a case": "Selecteer een dossier",
  "Select a client": "Selecteer een klant",
  "Select a department": "Selecteer een afdeling",
  "Select a division": "Selecteer een divisie",
  "Select an employer": "Selecteer een werkgever",
  "Selected · not on this page": "Geselecteerd · niet op deze pagina",
  "Send code": "Code versturen",
  "Send email": "E-mail sturen",
  "Send reset link": "Verstuur link",
  "Sending…": "Bezig met verzenden…",
  "Set by your administrator.": "Ingesteld door uw beheerder.",
  "Set your password": "Wachtwoord instellen",
  "Settings": "Instellingen",
  "Shifts on actual dates, filled in as they are known": "Diensten op echte datums, ingevuld zodra ze bekend zijn",
  "Shortening the rotation removes days that hold shifts.": "Door de rotatie in te korten verdwijnen dagen met diensten.",
  "Show list": "Lijst tonen",
  "Sick report": "Ziekmelding",
  "Sign out after": "Uitloggen na",
  "Sign out now": "Nu uitloggen",
  "Sign out?": "Uitloggen?",
  "Signature": "Handtekening",
  "Signature actions for {role}": "Acties voor de handtekening van {role}",
  "Signature rejected": "Ondertekening geweigerd",
  "Signature removed": "Handtekening verwijderd",
  "Signature uploaded": "Handtekening geüpload",
  "Signing in…": "Bezig met inloggen…",
  "Something went wrong": "Er is iets misgegaan",
  "Standby": "Stand-by",
  "Standby {hours}h": "Stand-by {hours}u",
  "Start": "Begin",
  "Start consultation": "Start spreekuur",
  "Start of employment": "Begin dienstverband",
  "Start on or after {date}": "Begin op of na {date}",
  "Start on or before {date}, when the employment ends": "Begin op of voor {date}, wanneer het dienstverband eindigt",
  "Starts on": "Begint op",
  "State or province": "Provincie",
  "Stay signed in": "Ingelogd blijven",
  "Street": "Straat",
  "Street 2": "Adresregel 2",
  "Subscribe to your agenda in Apple Calendar, Google Calendar or Outlook.": "Abonneer u op uw agenda in Apple Agenda, Google Agenda of Outlook.",
  "Subscription link": "Abonnementslink",
  "Suffix": "Achtervoegsel",
  "Superseded": "Vervangen",
  "Supervisor": "Leidinggevende",
  "Switch employment": "Dienstverband wisselen",
  "Switch language to Dutch": "Taal wijzigen naar Nederlands",
  "Switch language to English": "Taal wijzigen naar Engels",
  "System": "Systeem",
  "That code could not be verified. Please try again.": "Die code kon niet worden geverifieerd. Probeer het opnieuw.",
  "The draft is deleted. This cannot be undone.": "Het concept wordt verwijderd. Dit kan niet ongedaan worden gemaakt.",
  "The file is deleted from your profile. You can upload a new one at any time.": "Het bestand wordt van uw profiel verwijderd. U kunt op elk moment een nieuw bestand uploaden.",
  "The ORL application should open automatically.": "De ORL-applicatie wordt automatisch geopend.",
  "The break must be shorter than the period": "De pauze moet korter zijn dan de periode",
  "The chosen employment’s repeating schedule starts here on this date.": "Het herhalende rooster van het gekozen dienstverband begint hier op deze datum.",
  "The dossier appears here.": "Het dossier verschijnt hier.",
  "The list shows only what matches every filter.": "De lijst toont alleen wat aan elk filter voldoet.",
  "The migrated schedule has conflicts that need correcting": "Het overgezette rooster bevat conflicten die gecorrigeerd moeten worden",
  "The previous version runs on in its place.": "De vorige versie loopt in plaats daarvan door.",
  "The same seven days every week": "Elke week dezelfde zeven dagen",
  "The work schedule entered for this employment appears here.": "Het werkrooster van dit dienstverband verschijnt hier.",
  "The work schedule was changed by someone else. Reload it and try again.": "Iemand anders heeft het werkrooster gewijzigd. Herlaad het en probeer het opnieuw.",
  "The work schedule was reloaded. Enter your changes again on the current version.": "Het werkrooster is opnieuw geladen. Voer uw wijzigingen opnieuw in op de huidige versie.",
  "There is already a version starting {date}. Correct or delete it to change the schedule before then.": "Er is al een versie die begint op {date}. Corrigeer of verwijder die om het rooster daarvoor te wijzigen.",
  "This absence changed while you were filling this in. Reload to see it.": "Dit verzuim is gewijzigd terwijl u dit invulde. Herlaad om het te zien.",
  "This case": "Dit dossier",
  "This date": "Deze datum",
  "This date is outside the roster": "Deze datum valt buiten het rooster",
  "This link is no longer valid": "Deze link is niet langer geldig",
  "This list isn't available": "Deze lijst is niet beschikbaar",
  "This month": "Deze maand",
  "This page is not available yet.": "Deze pagina is nog niet beschikbaar.",
  "This part of the dossier arrives in a later release.": "Dit deel van het dossier volgt in een latere release.",
  "This part of the dossier is no longer available to you": "Dit deel van het dossier is niet langer voor u beschikbaar",
  "This version or date no longer exists. The schedule was reloaded.": "Deze versie of datum bestaat niet meer. Het rooster is opnieuw geladen.",
  "Timeline": "Tijdlijn",
  "Times": "Tijden",
  "Title": "Titel",
  "To": "Tot",
  "Too many attempts. Please wait a minute and try again.": "Te veel pogingen. Wacht een minuut en probeer het opnieuw.",
  "Try again": "Opnieuw proberen",
  "Two-factor authentication": "Tweefactorauthenticatie",
  "Type to search…": "Typ om te zoeken…",
  "Unassigned": "Niet toegewezen",
  "Unknown": "Onbekend",
  "Unknown author": "Onbekende auteur",
  "Unknown employer": "Onbekende werkgever",
  "Untitled document": "Naamloos document",
  "Upcoming": "Toekomstig",
  "Upload": "Uploaden",
  "Upload certificate for {role}": "Certificaat uploaden voor {role}",
  "Upload signature for {role}": "Handtekening uploaden voor {role}",
  "Use a different email": "Ander e-mailadres gebruiken",
  "Use a percentage between 1 and 100": "Gebruik een percentage tussen 1 en 100",
  "Use a whole percentage": "Gebruik een heel percentage",
  "Use at least 12 characters": "Gebruik minimaal 12 tekens",
  "Use at least 6 characters": "Gebruik minimaal 6 tekens",
  "Use at least 8 characters": "Gebruik minimaal 8 tekens",
  "Use at most 10 characters": "Gebruik maximaal 10 tekens",
  "Use at most 100 characters": "Gebruik maximaal 100 tekens",
  "Use at most 16 characters": "Gebruik maximaal 16 tekens",
  "Use at most 20 characters": "Gebruik maximaal 20 tekens",
  "Use at most 50 characters": "Gebruik maximaal 50 tekens",
  "Variable roster": "Wisselend rooster",
  "Verification code": "Verificatiecode",
  "Verified": "Geverifieerd",
  "Verify": "Verifiëren",
  "Verifying your email…": "Uw e-mailadres wordt geverifieerd…",
  "Verifying…": "Bezig met verifiëren…",
  "Version deleted": "Versie verwijderd",
  "Versions": "Versies",
  "View": "Bekijken",
  "View certificate for {role}": "Certificaat bekijken voor {role}",
  "View signature for {role}": "Handtekening bekijken voor {role}",
  "Visible to you and to administrators.": "Zichtbaar voor u en voor beheerders.",
  "Visiting address": "Bezoekadres",
  "We could not upload this file. Please try again.": "Het bestand kon niet worden geüpload. Probeer het opnieuw.",
  "WIA application": "WIA-aanvraag",
  "Waiting on an employer": "Wacht op een werkgever",
  "We could not change your password. Please try again.": "We konden uw wachtwoord niet wijzigen. Probeer het opnieuw.",
  "We could not open the ORL application.": "We konden de ORL-applicatie niet openen.",
  "We could not regenerate the calendar link. Please try again.": "We konden de agendalink niet opnieuw genereren. Probeer het opnieuw.",
  "We could not register the recovery. Please try again.": "We konden het herstel niet registreren. Probeer het opnieuw.",
  "We could not reset your password. Please try again.": "We konden uw wachtwoord niet opnieuw instellen. Probeer het opnieuw.",
  "We could not save the work schedule. Please try again.": "We konden het werkrooster niet opslaan. Probeer het opnieuw.",
  "We could not save your idle timeout. Please try again.": "We konden uw time-out niet opslaan. Probeer het opnieuw.",
  "We could not save your profile. Please try again.": "We konden uw profiel niet opslaan. Probeer het opnieuw.",
  "We could not send the link. Please try again.": "We konden de link niet versturen. Probeer het opnieuw.",
  "We could not sign you in. Please try again.": "We konden u niet inloggen. Probeer het opnieuw.",
  "We could not start the email change. Please try again.": "We konden de wijziging van uw e-mailadres niet starten. Probeer het opnieuw.",
  "We could not update your photo. Please try again.": "We konden uw foto niet bijwerken. Probeer het opnieuw.",
  "We send a code to the new address. The change applies once you enter it, and signs you out everywhere.": "We sturen een code naar het nieuwe adres. De wijziging gaat in zodra u die invoert, en u wordt overal uitgelogd.",
  "We will email you a link to choose a new password.": "We sturen u een e-mail met een link om een nieuw wachtwoord te kiezen.",
  "Website": "Website",
  "Week": "Week",
  "Week 42 UWV report": "42e-weekmelding UWV",
  "Week total": "Weektotaal",
  "Week {n}": "Week {n}",
  "What kind of schedule?": "Wat voor rooster?",
  "What this day is": "Wat deze dag is",
  "What you entered is not saved.": "Wat u hebt ingevuld, wordt niet opgeslagen.",
  "Which cases": "Welke dossiers",
  "Work": "Werk",
  "Work aspects": "Werkaspecten",
  "Work hours": "Werkuren",
  "Work number": "Telefoonnummer werk",
  "Work queue": "Werkvoorraad",
  "Work schedule": "Werkrooster",
  "Work schedule saved": "Werkrooster opgeslagen",
  "Workbench": "Werkbank",
  "Workbench opens on": "Werkbank opent op",
  "Which view the Workbench shows when you open it.": "Welk overzicht de werkbank toont als u hem opent.",
  "Default for my role ({home})": "Standaard voor mijn rol ({home})",
  "Queue": "Werkvoorraad",
  "Consultations": "Spreekuren",
  "Workbench preference saved": "Voorkeur voor de werkbank opgeslagen",
  "We could not save your Workbench preference. Please try again.": "We konden uw voorkeur voor de werkbank niet opslaan. Probeer het opnieuw.",
  "Workday": "Werkdag",
  "You already have a draft for this consult. It is open in the note editor.": "U heeft al een concept voor dit consult. Het staat open in de notitie-editor.",
  "You are signed in": "U bent ingelogd",
  "You don't have access to clients": "U heeft geen toegang tot klanten",
  "You don't have access to departments": "U heeft geen toegang tot afdelingen",
  "You don't have access to divisions": "U heeft geen toegang tot divisies",
  "You don't have access to employers": "U heeft geen toegang tot werkgevers",
  "You don't have access to persons": "U heeft geen toegang tot personen",
  "You don't have access to the caseload": "Je hebt geen toegang tot de caseload",
  "You don't have access to the work queue": "U heeft geen toegang tot de werkvoorraad",
  "You don't have access to this client": "U heeft geen toegang tot deze klant",
  "You don't have access to this department": "U heeft geen toegang tot deze afdeling",
  "You don't have access to this division": "U heeft geen toegang tot deze divisie",
  "You don't have access to this employer": "U heeft geen toegang tot deze werkgever",
  "You don't have access to this list": "U heeft geen toegang tot deze lijst",
  "You don't have access to this person's file": "U heeft geen toegang tot het dossier van deze persoon",
  "You don't have access to this work schedule": "Je hebt geen toegang tot dit werkrooster",
  "You have been inactive for a while. To protect patient data, you will be signed out in {time}.": "U bent een tijdje inactief geweest. Ter bescherming van patiëntgegevens wordt u over {time} uitgelogd.",
  "You have been signed out in another tab.": "U bent in een ander tabblad uitgelogd.",
  "You were signed out because you were inactive.": "U bent uitgelogd omdat u inactief was.",
  "You will be signed out in {time}.": "U wordt over {time} uitgelogd.",
  "You will need to sign in again to continue.": "U moet opnieuw inloggen om verder te gaan.",
  "Your access changed while this page was open.": "Uw toegang is gewijzigd terwijl deze pagina open stond.",
  "Your account has been frozen. Please contact an administrator.": "Uw account is geblokkeerd. Neem contact op met een beheerder.",
  "Your account is active. The next step is to set your password.": "Uw account is actief. De volgende stap is het instellen van uw wachtwoord.",
  "Your address and phone numbers.": "Uw adres en telefoonnummers.",
  "Your changes on this tab have not been saved.": "Uw wijzigingen op dit tabblad zijn niet opgeslagen.",
  "Your email address has changed. Sign in with your new address.": "Uw e-mailadres is gewijzigd. Log in met uw nieuwe adres.",
  "Your initials will be shown instead.": "In plaats daarvan worden uw initialen getoond.",
  "Your name and gender.": "Uw naam en geslacht.",
  "Your organisation allows at most {minutes} minutes.": "Uw organisatie staat maximaal {minutes} minuten toe.",
  "Your session has expired. Please sign in again.": "Uw sessie is verlopen. Log opnieuw in.",
  "Your sign-in timed out. Please sign in again.": "Uw inlogpoging is verlopen. Log opnieuw in.",
  "Your unsaved changes were discarded.": "Uw niet-opgeslagen wijzigingen zijn verworpen.",
  "ends the next day": "eindigt de volgende dag",
  "wk {week}/{total}": "wk {week}/{total}",
  "{count} day in conflict | {count} days in conflict": "{count} dag met conflict | {count} dagen met conflict",
  "{count} unknown day | {count} unknown days": "{count} onbekende dag | {count} onbekende dagen",
  "{count} unread notifications": "{count} ongelezen melding | {count} ongelezen meldingen",
  "{date}: off": "{date}: vrij",
  "{from} – {to}: off": "{from} – {to}: vrij",
  "{from}–{to} of {total}": "{from}–{to} van {total}",
  "{hours}h": "{hours}u",
  "{hours}h standby": "{hours}u stand-by",
  "{hours}h work": "{hours}u werk",
  "{percentage}% employable": "{percentage}% arbeidsgeschikt",
  "Reasoned deviation": "Gemotiveerde afwijking",
  "Long-term absence apparent later": "Langdurig verzuim pas later duidelijk",
  "No exploitable possibilities": "Geen benutbare mogelijkheden",
  "Marginal possibilities": "Marginale mogelijkheden",
  "Concrete return prospect in the own organisation": "Concreet uitzicht op terugkeer in de eigen organisatie",
  "Return to own work expected": "Terugkeer in eigen werk verwacht",
  "Structural return realised": "Structurele terugkeer gerealiseerd",
  "AOW age within one year": "AOW-leeftijd binnen een jaar",
  "Employer and employee": "Werkgever en werknemer",
  "Record exception": "Uitzondering vastleggen",
  "Withdraw exception": "Uitzondering intrekken",
  "Add note": "Notitie toevoegen",
  "Save note": "Notitie opslaan",
  "Reason": "Reden",
  "Choose a reason": "Kies een reden",
  "Note": "Notitie",
  "Due": "Uiterlijk",
  "Back": "Terug",
  "(optional)": "(optioneel)",
  "Date the employee agreed": "Datum waarop de werknemer akkoord ging",
  "Decided by": "Besloten door",
  "Decided by UWV": "Besloten door UWV",
  "Recorded by": "Vastgelegd door",
  "Why are you withdrawing this?": "Waarom trekt u dit in?",
  "The obligation returns to whatever its schedule says, and may show as overdue.": "De verplichting keert terug naar wat het schema aangeeft en kan als te laat worden getoond.",
  "The obligations return to whatever the schedule says, and may show as overdue.": "De verplichtingen keren terug naar wat het schema aangeeft en kunnen als te laat worden getoond.",
  "This note is not a medical record. Do not include a diagnosis, cause, treatment or vangnet status. Clinical reasoning belongs in the encounter note.": "Deze notitie is geen medisch dossier. Vermeld geen diagnose, oorzaak, behandeling of vangnetstatus. Medisch-inhoudelijke overwegingen horen in de spreekuurnotitie.",
  "Record the date the employee agreed": "Leg de datum vast waarop de werknemer akkoord ging",
  "The employee cannot have agreed in the future": "De werknemer kan niet in de toekomst akkoord zijn gegaan",
  "Say why you are withdrawing this exception": "Geef aan waarom u deze uitzondering intrekt",
  "Write the note": "Schrijf de notitie",
  "Keep the note under 2000 characters": "Houd de notitie korter dan 2000 tekens",
  "Keep the reason under 500 characters": "Houd de reden korter dan 500 tekens",
  "Early IVA awarded": "Vervroegde IVA toegekend",
  "Voluntary extension": "Vrijwillige verlenging",
  "Loonsanctie": "Loonsanctie",
  "Employment ended": "Dienstverband beëindigd",
  "UWV": "UWV",
  "UWV decisions": "Beslissingen van UWV",
  "No UWV decisions recorded": "Geen beslissingen van UWV vastgelegd",
  "Record a UWV decision": "Beslissing van UWV vastleggen",
  "Waiting period ends": "Wachttijd eindigt",
  "Decided on": "Beslist op",
  "Takes effect": "Ingangsdatum",
  "End date": "Einddatum",
  "Repair reported": "Herstel gemeld",
  "Repair accepted": "Herstel geaccepteerd",
  "Withdraw": "Intrekken",
  "Edit": "Bewerken",
  "This replaces the current record. Both are kept.": "Dit vervangt de huidige vastlegging. Beide blijven bewaard.",
  "Record the date on the decision": "Leg de datum op de beslissing vast",
  "UWV cannot have decided in the future": "UWV kan niet in de toekomst hebben beslist",
  "Record the end date on the decision": "Leg de einddatum op de beslissing vast",
  "Record the date the award takes effect": "Leg de ingangsdatum van de toekenning vast",
  "Say why you are withdrawing this record": "Geef aan waarom u deze vastlegging intrekt",
  "Pick a date": "Kies een datum",
  "Clear date": "Datum wissen",
  "This list could not be refreshed": "Deze lijst kon niet worden vernieuwd",
  "You are seeing what was loaded before.": "U ziet wat eerder is geladen.",
  "Refreshing": "Vernieuwen",
  "since {date}": "sinds {date}",
  "item overdue | items overdue": "item te laat | items te laat",
  "item due within 7 days | items due within 7 days": "item met een deadline binnen 7 dagen | items met een deadline binnen 7 dagen",
  "task waiting on an employer | tasks waiting on an employer": "taak wacht op een werkgever | taken wachten op een werkgever",
  "{count} d": "{count} dgn",
  "No deadline": "Geen deadline",
  "Labour expert": "Arbeidsdeskundige",
  "Reintegration company": "Re-integratiebedrijf",
  "Other": "Overig",
  "{count} case without a WVP workflow | {count} cases without a WVP workflow": "{count} dossier zonder WVP-workflow | {count} dossiers zonder WVP-workflow",
  "Show in My caseload": "Tonen in Mijn caseload",
  "Appointment": "Afspraak",
  "All day": "Hele dag",
  "Done": "Afgerond",
  "No-show": "Niet verschenen",
  "{count} min": "{count} min",
  "Today": "Vandaag",
  "No appointments today": "Geen afspraken vandaag",
  "You don't have access to your appointments": "U heeft geen toegang tot uw afspraken",
  "{count} appointment | {count} appointments": "{count} afspraak | {count} afspraken",
  "Tasks": "Taken",
  "Activities": "Activiteiten",
  "Invoiced": "Gefactureerd",
  "Halted": "Gestopt",
  "Executed": "Uitgevoerd",
  "Deleted": "Verwijderd",
  "Paid": "Betaald",
  "Waiting on {party}": "Wacht op {party}",
  "Everyone": "Iedereen",
  "Add filter": "Filter toevoegen",
  "Form {done}/{total}": "Formulier {done}/{total}",
  "Survey": "Vragenlijst",
  "Document": "Document",
  "No open items": "Geen open items",
  "No open activities": "Geen open activiteiten",
  "No invoiced items": "Geen gefactureerde items",
  "Invoiced items are read-only": "Gefactureerde items zijn alleen-lezen",
  "You don't have access to the action list": "U heeft geen toegang tot de actielijst",
  "Category": "Categorie",
  "Assignee {id}": "Toegewezen aan {id}",
  "On time": "Op tijd",
  "Activity": "Activiteit",
  "Consult mode": "Consultmodus",
  "Encounter note": "Spreekuurnotitie",
  "Awaiting approval": "Wacht op goedkeuring",
  "{count}d": "{count}d",
  "{count} day old | {count} days old": "{count} dag oud | {count} dagen oud",
  "by {name}": "door {name}",
  "Task": "Taak",
  "Task delegation": "Taakdelegatie",
  "To finish": "Af te ronden",
  "oldest first": "oudste eerst",
  "{count} item to finish | {count} items to finish": "{count} item af te ronden | {count} items af te ronden",
  "Nothing to finish": "Niets af te ronden",
  "You don't have access to your unfinished work": "U heeft geen toegang tot uw openstaande werk",
  "Requests": "Verzoeken",
  "asked of you": "aan u gevraagd",
  "{count} request | {count} requests": "{count} verzoek | {count} verzoeken",
  "No requests": "Geen verzoeken",
  "You don't have access to your requests": "U heeft geen toegang tot uw verzoeken",
  "{count} employer update | {count} employer updates": "{count} update van werkgever | {count} updates van werkgever",
  "{count} notification | {count} notifications": "{count} melding | {count} meldingen",
  "First contact": "Eerste contact",
  "New since {date}: {changes}": "Nieuw sinds {date}: {changes}",
  "Nothing new since {date}": "Niets nieuws sinds {date}",
  "consultation today | consultations today": "spreekuur vandaag | spreekuren vandaag",
  "to finish": "af te ronden",
  "request for you | requests for you": "verzoek aan u | verzoeken aan u",
  "Findings, workload, agreements…": "Bevindingen, belastbaarheid, afspraken…",
  "Consult date": "Consultdatum",
  "Medical: only you see this draft": "Medisch: alleen u ziet dit concept",
  "Saved {time}": "Opgeslagen {time}",
  "Not saved yet": "Nog niet opgeslagen",
  "Offline. Your text is kept here and saved when the connection returns.": "Offline. Uw tekst blijft hier staan en wordt opgeslagen zodra er weer verbinding is.",
  "This draft was changed in another window at {time}": "Dit concept is in een ander venster gewijzigd om {time}",
  "Use that version": "Die versie gebruiken",
  "Keep mine": "Mijn versie houden",
  "This draft no longer exists. It was finalised or deleted in another window.": "Dit concept bestaat niet meer. Het is in een ander venster afgerond of verwijderd.",
  "Save as a new draft": "Opslaan als nieuw concept",
  "Replace your text?": "Uw tekst vervangen?",
  "What you typed here is replaced by the version from the other window.": "Wat u hier hebt getypt, wordt vervangen door de versie uit het andere venster.",
  "Your note could not be loaded.": "Uw notitie kon niet worden geladen.",
  "Good morning": "Goedemorgen",
  "Good afternoon": "Goedemiddag",
  "Good evening": "Goedenavond",
  "Good morning, {name}": "Goedemorgen, {name}",
  "Good afternoon, {name}": "Goedemiddag, {name}",
  "Good evening, {name}": "Goedenavond, {name}",
  "Describe what was done": "Beschrijf wat er is gedaan",
  "Task completed": "Taak afgerond",
  "You can't complete this task.": "U kunt deze taak niet afronden.",
  "This task is no longer open.": "Deze taak staat niet meer open.",
  "We could not load this task. Please try again.": "We konden deze taak niet laden. Probeer het opnieuw.",
  "What was done": "Wat is er gedaan",
  "Execute": "Uitvoeren",
  "Complete this task in the previous portal.": "Rond deze taak af in het vorige portaal.",
  "Open in the previous portal": "Openen in het vorige portaal",
  "This certificate is signed and can no longer be changed.": "Dit certificaat is ondertekend en kan niet meer worden gewijzigd.",
  "Complete task": "Taak afronden",
  "Draft saved": "Concept opgeslagen",
  "Form completed": "Formulier afgerond",
  "Save draft": "Concept opslaan",
  "Optional": "Optioneel",
  "Form": "Formulier",
  "Forms in this task": "Formulieren in deze taak",
  "Save your changes first?": "Eerst uw wijzigingen opslaan?",
  "Complete form": "Formulier afronden",
  "Generate forms": "Formulieren genereren",
  "Generate forms from this note": "Formulieren genereren uit deze notitie",
  "Scribe fills the forms of the task you choose with this note. You review the drafts before anything is final.": "Scribe vult met deze notitie de formulieren van de gekozen taak. U beoordeelt de concepten voordat iets definitief is.",
  "Choose a task": "Kies een taak",
  "No form tasks on this case": "Geen formuliertaken in deze casus",
  "Could not load the form tasks.": "De formuliertaken konden niet worden geladen.",
  "Generate": "Genereren",
  "Queued": "In wachtrij",
  "Generating": "Bezig met genereren",
  "Ready: {count} forms": "Klaar: {count} formulieren",
  "Failed": "Mislukt",
  "AI drafts generated": "AI-concepten gegenereerd",
  "Review them in the Action list": "Beoordeel ze in de actielijst",
  "Still generating. Check the Action list later.": "Nog bezig met genereren. Kijk later in de actielijst.",
  "You can't generate forms for this task": "U kunt voor deze taak geen formulieren genereren",
  "Advice released": "Advies vrijgegeven",
  "Both": "Beide",
  "Release": "Vrijgeven",
  "Release as advice": "Vrijgeven als advies",
  "The document is recorded as released advice. The encounter note itself never leaves the practice.": "Het document wordt vastgelegd als vrijgegeven advies. De spreekuurnotitie zelf verlaat de praktijk nooit.",
  "We could not record this. Please try again.": "We konden dit niet vastleggen. Probeer het opnieuw.",
  "Who receives this advice?": "Wie ontvangt dit advies?",
  "You can't release this document": "U kunt dit document niet vrijgeven",
  "Cancel task": "Taak annuleren",
  "Change task owner": "Taakeigenaar wijzigen",
  "Cancel activity": "Activiteit annuleren",
  "Mark as no-show": "Markeren als niet verschenen",
  "Cancel this task?": "Deze taak annuleren?",
  "Cancel this activity?": "Deze activiteit annuleren?",
  "Mark this activity as no-show?": "Deze activiteit markeren als niet verschenen?",
  "All its open tasks are cancelled.": "Alle openstaande taken worden geannuleerd.",
  "All its open tasks are marked as no-show.": "Alle openstaande taken worden gemarkeerd als niet verschenen.",
  "This ends the activity. You can record why.": "Hiermee wordt de activiteit beëindigd. U kunt vastleggen waarom.",
  "No reason": "Geen reden",
  "Explanation": "Toelichting",
  "Too early": "Te vroeg",
  "Too late": "Te laat",
  "Wrong location": "Verkeerde locatie",
  "Wrong professional": "Verkeerde professional",
  "Patient unavailable": "Cliënt niet beschikbaar",
  "Say why you are cancelling": "Geef aan waarom u annuleert",
  "Keep the explanation under 500 characters": "Houd de toelichting onder 500 tekens",
  "Every task of this activity is already closed.": "Alle taken van deze activiteit zijn al afgesloten.",
  "We could not load this activity's tasks.": "We konden de taken van deze activiteit niet laden.",
  "We could not load who can take this task.": "We konden niet laden wie deze taak kan overnemen.",
  "No one else can take this task.": "Niemand anders kan deze taak overnemen.",
  "New owner": "Nieuwe eigenaar",
  "Change owner": "Eigenaar wijzigen",
  "You can't change this task.": "U kunt deze taak niet wijzigen.",
  "This task is no longer available.": "Deze taak is niet meer beschikbaar.",
  "Task cancelled": "Taak geannuleerd",
  "Activity cancelled": "Activiteit geannuleerd",
  "Marked as no-show": "Gemarkeerd als niet verschenen",
  "Task owner changed": "Taakeigenaar gewijzigd",
  "This task is already closed.": "Deze taak is al afgesloten.",
  "Draft approved": "Concept goedgekeurd",
  "Drafts approved": "Concepten goedgekeurd",
  "The diagnosis code list is not available.": "De lijst met diagnosecodes is niet beschikbaar.",
  "This AI draft changed. Review it again.": "Dit AI-concept is gewijzigd. Controleer het opnieuw.",
  "Possible privacy leak": "Mogelijk privacylek",
  "Possibly made up": "Mogelijk verzonnen",
  "Scribe reported a problem": "Scribe meldde een probleem",
  "Whole form": "Hele formulier",
  "Scribe raised no warnings on this form.": "Scribe gaf geen waarschuwingen op dit formulier.",
  "Approve form": "Formulier goedkeuren",
  "Approve all drafts": "Alle concepten goedkeuren",
  "AI draft": "AI-concept",
  "AI drafts with Scribe": "AI-concepten met Scribe",
  "Generate drafts with AI": "Concepten genereren met AI",
  "Choose a saved note": "Kies een opgeslagen notitie",
  "Or type notes for Scribe": "Of typ notities voor Scribe",
  "Generating drafts…": "Concepten worden gegenereerd…",
  "Scribe is taking longer than expected. Check again later.": "Scribe doet er langer over dan verwacht. Kijk later opnieuw.",
  "Scribe could not generate drafts.": "Scribe kon geen concepten genereren.",
  "You can't generate drafts for this task.": "Je kunt voor deze taak geen concepten genereren.",
  "Scribe withheld a draft for: {forms}": "Scribe heeft geen concept gemaakt voor: {forms}",
  "AI draft withheld": "AI-concept achtergehouden",
  "{n} drafts ready for review": "Eén concept klaar om te controleren | {n} concepten klaar om te controleren",
  "Use a saved note": "Een opgeslagen notitie gebruiken",
  "You can't use this case's notes.": "Je kunt de notities van deze casus niet gebruiken.",
  "Generate again": "Opnieuw genereren",
  "Choose a note": "Kies een notitie",
  "Review the AI draft before approving": "Controleer het AI-concept voor goedkeuren",
  "{done} of {total} reviewed": "{done} van {total} gecontroleerd",
  "Save your changes to approve this form.": "Sla je wijzigingen op om dit formulier goed te keuren.",
  "Review every warning to approve this form.": "Controleer elke waarschuwing om dit formulier goed te keuren.",
  "Type at least two characters to search.": "Typ minstens twee tekens om te zoeken.",
  "Certificate updated": "Certificaat bijgewerkt",
  "The document editor is not available.": "De documenteditor is niet beschikbaar.",
  "Could not refresh the certificate.": "Het certificaat kon niet worden vernieuwd.",
  "Update the certificate?": "Certificaat bijwerken?",
  "Updating regenerates the certificate with the latest data.": "Bijwerken maakt het certificaat opnieuw aan met de nieuwste gegevens.",
  "Sign this certificate from the dossier's Documents tab once the task is completed.": "Onderteken dit certificaat via het tabblad Documenten van het dossier zodra de taak is afgerond.",
  "Refresh": "Vernieuwen",
  "Update": "Bijwerken",
  "Your edits could not be saved. Try again.": "Je wijzigingen konden niet worden opgeslagen. Probeer het opnieuw.",
  "A document is signed and is the final version.": "Een document is ondertekend en is de definitieve versie.",
  "Could not refresh the document.": "Het document kon niet worden vernieuwd.",
  "Edit document": "Document bewerken",
  "Stop editing": "Stoppen met bewerken",
  "Document saved": "Document opgeslagen",
  "Leave the document?": "Document verlaten?",
  "Edits the editor has not saved yet are lost.": "Wijzigingen die de editor nog niet heeft opgeslagen gaan verloren.",
  "Leave": "Verlaten",
  "Choose a role": "Kies een rol",
  "Add a signature image": "Voeg een handtekeningafbeelding toe",
  "Keep the notes under 1000 characters": "Houd de notities onder 1000 tekens",
  "Signature saved": "Handtekening opgeslagen",
  "Signature set as active": "Handtekening actief gemaakt",
  "Signature deleted": "Handtekening verwijderd",
  "This signature is no longer available": "Deze handtekening is niet meer beschikbaar",
  "Draw your signature": "Teken uw handtekening",
  "Add signature": "Handtekening toevoegen",
  "Edit signature": "Handtekening bewerken",
  "Upload an image or draw your signature.": "Upload een afbeelding of teken uw handtekening.",
  "We could not load your roles.": "We konden uw rollen niet laden.",
  "Draw": "Tekenen",
  "Choose image": "Afbeelding kiezen",
  "PNG, JPEG or WebP, up to 5 MB.": "PNG, JPEG of WebP, maximaal 5 MB.",
  "Set as active": "Als actief instellen",
  "Signing uses the active signature for this role.": "Bij ondertekenen wordt de actieve handtekening voor deze rol gebruikt.",
  "Save signature": "Handtekening opslaan",
  "No role": "Geen rol",
  "Inactive": "Inactief",
  "Set active": "Actief maken",
  "Edit {name}": "{name} bewerken",
  "Delete {name}": "{name} verwijderen",
  "Signatures": "Handtekeningen",
  "No signatures yet": "Nog geen handtekeningen",
  "Add a signature to sign documents for your role.": "Voeg een handtekening toe om documenten voor uw rol te ondertekenen.",
  "Delete this signature?": "Deze handtekening verwijderen?",
  "The signature is deleted. Documents already signed with it keep it.": "De handtekening wordt verwijderd. Documenten die er al mee zijn ondertekend, behouden haar.",
  "Preview unavailable": "Voorbeeld niet beschikbaar",
  "The active signature is used when you sign a document for that role.": "De actieve handtekening wordt gebruikt wanneer u een document voor die rol ondertekent.",
  "Add signature for {role}": "Handtekening toevoegen voor {role}",
  "Used when you sign as {role}": "Gebruikt wanneer u ondertekent als {role}",
  "No active signature. You can't sign as {role} until you set one active.": "Geen actieve handtekening. U kunt pas ondertekenen als {role} wanneer u er een actief maakt.",
  "No signature yet. You can't sign as {role} until you add one.": "Nog geen handtekening. U kunt pas ondertekenen als {role} wanneer u er een toevoegt.",
  "Other signatures": "Andere handtekeningen",
  "This is the active signature for {role}. You can't sign as {role} until you set another one active.": "Dit is de actieve handtekening voor {role}. U kunt pas ondertekenen als {role} wanneer u een andere actief maakt.",
  "Could not download this document.": "Dit document kon niet worden gedownload.",
  "Download": "Downloaden",
  "You can't sign this document": "U kunt dit document niet ondertekenen",
  "Document fully signed": "Document volledig ondertekend",
  "Document partially signed. More signatures are still needed.": "Document gedeeltelijk ondertekend. Er zijn nog meer handtekeningen nodig.",
  "Sign": "Ondertekenen",
  "Sign document": "Document ondertekenen",
  "This document requires the {role} signature.": "Dit document vereist de handtekening van {role}.",
  "Awaiting: {types}": "Wacht op: {types}",
  "You have no active signature for {role}.": "U heeft geen actieve handtekening voor {role}.",
  "You have no active signature.": "U heeft geen actieve handtekening.",
  "Manage signatures": "Handtekeningen beheren",
  "Choose a signature": "Kies een handtekening",
  "Could not load this document.": "Dit document kon niet worden geladen.",
  "Absence contact": "Verzuimcontactpersoon",
  "HSE contact": "VGM-contactpersoon",
  "Employer main contact": "Hoofdcontactpersoon werkgever",
  "Client main contact": "Hoofdcontactpersoon klant",
  "The document could not be signed. Please try again.": "Het document kon niet worden ondertekend. Probeer het opnieuw.",
  "{shown} of {total}": "{shown} van {total}",
  "Conclude activity": "Activiteit afronden",
  "Conclude this activity?": "Deze activiteit afronden?",
  "Conclude": "Afronden",
  "Activity concluded": "Activiteit afgerond",
  "This activity is not invoiced.": "Deze activiteit wordt niet gefactureerd.",
  "We could not check this activity.": "We konden deze activiteit niet controleren.",
  "Time spent (minutes)": "Bestede tijd (minuten)",
  "Time spent (minutes, optional)": "Bestede tijd (minuten, optioneel)",
  "Enter the time spent": "Vul de bestede tijd in",
  "Enter whole minutes, at least 1": "Vul hele minuten in, minimaal 1",
  "Amount excl. VAT": "Bedrag excl. btw",
  "VAT": "Btw",
  "Total": "Totaal",
  "Day": "Dag",
  "Month": "Maand",
  "Previous period": "Vorige periode",
  "Next period": "Volgende periode",
  "Go to date": "Ga naar datum",
  "No appointments this day": "Geen afspraken op deze dag",
  "No appointments this week": "Geen afspraken deze week",
  "No appointments this month": "Geen afspraken deze maand",
  "Calendar": "Kalender",
  "List": "Lijst",
  "Appointment moved": "Afspraak verplaatst",
  "Undo": "Ongedaan maken",
  "Could not move the appointment.": "De afspraak kon niet worden verplaatst.",
  "Appointment scheduled": "Afspraak ingepland",
  "Pick a time inside your availability.": "Kies een tijd binnen je beschikbaarheid.",
  "This availability has no location, so it cannot be booked here.": "Deze beschikbaarheid heeft geen locatie en kan hier niet worden geboekt.",
  "This activity has no task you can book.": "Deze activiteit heeft geen taak die je kunt boeken.",
  "Schedule an appointment": "Afspraak inplannen",
  "Webshop": "Webshop",
  "Book for": "Boeken voor",
  "Person": "Persoon",
  "Choose…": "Kies…",
  "Choose an activity": "Kies een activiteit",
  "Room": "Kamer",
  "Choose a room": "Kies een kamer",
  "Signaling date": "Signaleringsdatum",
  "Private note": "Privé notitie",
  "Schedule": "Inplannen",
  "Yes, delete it": "Ja, verwijderen",
  "Delete recurring event?": "Herhalende afspraak verwijderen?",
  "Event deleted. Click Undo to restore.": "Afspraak verwijderd. Klik op Ongedaan maken om te herstellen.",
  "Event restored.": "Afspraak hersteld.",
  "Cannot restore: time slot is now taken.": "Herstellen niet mogelijk: het tijdslot is inmiddels bezet.",
  "Failed to restore event.": "Afspraak herstellen is mislukt.",
  "Failed to delete event.": "Afspraak verwijderen is mislukt.",
  "More actions for {name}": "Meer acties voor {name}",
  "Warning: \"All\" includes past instances as well. Use \"Following\" if you only want future events.": "Let op: \"Alle\" omvat ook eerdere afspraken. Gebruik \"Volgende\" als u alleen toekomstige afspraken wilt.",
  "Are you sure?": "Weet u het zeker?",
  "The whole appointment will be removed, with every task on it.": "De hele afspraak wordt verwijderd, met alle taken erop.",
  "You can undo this straight afterwards.": "U kunt dit direct daarna ongedaan maken.",
  "Delete appointment and activity list": "Afspraak en activiteitenlijst verwijderen",
  "This appointment created its activity list. Delete the list with it, or keep the list and remove the appointment only.": "Deze afspraak heeft zijn activiteitenlijst aangemaakt. Verwijder de lijst mee, of behoud de lijst en verwijder alleen de afspraak.",
  "Delete appointment only": "Alleen de afspraak verwijderen",
  "Recurring events restored.": "Herhalende afspraken hersteld.",
  "Recurring events deleted. Click Undo to restore.": "Herhalende afspraken verwijderd. Klik op Ongedaan maken om te herstellen.",
  "This event only": "Alleen deze afspraak",
  "Affects only the selected occurrence.": "Heeft alleen invloed op de geselecteerde afspraak.",
  "This and following events": "Deze en volgende afspraken",
  "Affects this event and every future event in the series.": "Heeft invloed op deze afspraak en alle toekomstige afspraken in de reeks.",
  "All events in series": "Alle afspraken in reeks",
  "Affects every event in the entire series.": "Heeft invloed op elke afspraak in de hele reeks.",
  "Contacts": "Contacten",
  "The professionals and employer contacts you work with.": "De professionals en werkgeverscontacten met wie je werkt.",
  "No contacts in your scope": "Geen contacten binnen je bereik",
  "You don't have access to contacts": "Je hebt geen toegang tot contacten",
  "Type": "Type",
  "Level": "Niveau",
  "Phone": "Telefoon",
  "Home": "Thuis",
  "Private": "Privé",
  "Employment": "Dienstverband",
  "Person's department": "Afdeling van de persoon",
  "Person's division": "Divisie van de persoon",
  "Person's employer": "Werkgever van de persoon",
  "Person's client": "Klant van de persoon",
  "Administrator": "Beheerder",
  "Privacy & legal": "Privacy en juridisch",
  "Privacy Policy": "Privacyverklaring",
  "Terms & Conditions": "Algemene voorwaarden",
  "Status": "Status",
  "Accepted": "Geaccepteerd",
  "Awaiting acceptance": "Wacht op acceptatie",
  "Accepted on": "Geaccepteerd op",
  "Last updated": "Laatst bijgewerkt",
  "Version": "Versie",
  "Download PDF": "PDF downloaden",
  "Document not available": "Document niet beschikbaar",
  "Review the document below": "Bekijk het document hieronder",
  "Email communication": "E-mailcommunicatie",
  "Enabled": "Ingeschakeld",
  "required": "verplicht",
  "Email communication is essential for the proper functioning of this portal and cannot be disabled.": "E-mailcommunicatie is essentieel voor het goed functioneren van dit portaal en kan niet worden uitgeschakeld.",
  "Platform information": "Platforminformatie",
  "This portal is technically provided by InCTRL, acting as a data processor on behalf of {organisation}.": "Dit portaal wordt technisch geleverd door InCTRL, als verwerker namens {organisation}.",
  "the organisation": "de organisatie",
  "Confidentiality reminder": "Vertrouwelijkheid",
  "Do not disclose medical diagnoses or detailed health information through employer-visible channels. Follow role-based access and security procedures.": "Deel geen medische diagnoses of gedetailleerde gezondheidsinformatie via kanalen die de werkgever kan zien. Volg de rolgebaseerde toegangs- en beveiligingsprocedures.",
  "A new version is waiting for your acceptance": "Er staat een nieuwe versie klaar voor uw acceptatie",
  "Below you can review the privacy and legal documents applicable to your use of this Professional Portal, as well as essential communication information.": "Hieronder vindt u de privacy- en juridische documenten die gelden voor uw gebruik van dit Professional Portal, en de essentiële informatie over communicatie.",
  "You don't have access to this page": "U heeft geen toegang tot deze pagina",
  "Acceptable use / no misuse": "Acceptabel gebruik / geen misbruik",
  "Access and key actions may be logged for security and audit purposes.": "Toegang en belangrijke acties kunnen worden gelogd voor beveiligings- en auditdoeleinden.",
  "All items must be confirmed to continue": "Alle items moeten worden bevestigd om door te gaan",
  "All set": "Klaar",
  "Check all": "Alles aanvinken",
  "Complete the required steps to continue": "Voltooi de vereiste stappen om door te gaan",
  "Confidentiality and restricted access": "Vertrouwelijkheid en beperkte toegang",
  "Confirm & Start": "Bevestigen & Starten",
  "Continue": "Doorgaan",
  "Data minimization": "Gegevensminimalisatie",
  "Do not disclose medical diagnoses or detailed health information through employer-visible channels": "Onthul geen medische diagnoses of gedetailleerde gezondheidsinformatie via werkgever-zichtbare kanalen",
  "Do not misuse the system or access data outside your permissions": "Misbruik het systeem niet en krijg geen toegang tot gegevens buiten uw machtigingen",
  "Documents have been updated": "Documenten zijn bijgewerkt",
  "Email communication is required for using this portal. We use email to ensure you receive time-sensitive and service-critical information.": "E-mailcommunicatie is vereist voor het gebruik van dit portaal. We gebruiken e-mail om ervoor te zorgen dat u tijdgevoelige en servicekritieke informatie ontvangt.",
  "Emails are used for important updates, required actions, appointment changes, security notices, and shared documents.": "E-mails worden gebruikt voor belangrijke updates, vereiste acties, afspraakwijzigingen, beveiligingsmeldingen en gedeelde documenten.",
  "Employer information boundaries": "Grenzen werkgeversinformatie",
  "Essential email communication": "Essentiële e-mailcommunicatie",
  "Essential email communication acknowledged": "Essentiële e-mailcommunicatie erkend",
  "Follow role-based access and keep credentials secure": "Volg rolgebaseerde toegang en houd inloggegevens veilig",
  "I have read and accept the Terms & Conditions of {organization}.": "Ik heb de Algemene Voorwaarden van {organization} gelezen en accepteer deze.",
  "I have read and understood the Privacy Policy of {organization}.": "Ik heb het Privacybeleid van {organization} gelezen en begrepen.",
  "I understand that employer-facing information must remain work-related and must not include medical diagnoses or detailed health information. I will ensure medical details are recorded only in appropriate restricted areas and not disclosed through employer-visible channels.": "Ik begrijp dat werkgevergerichte informatie werkgerelateerd moet blijven en geen medische diagnoses of gedetailleerde gezondheidsinformatie mag bevatten. Ik zal ervoor zorgen dat medische details alleen worden geregistreerd in passende afgeschermde gebieden en niet worden vrijgegeven via werkgever-zichtbare kanalen.",
  "I understand that essential service emails are required to use this portal.": "Ik begrijp dat essentiële service-e-mails vereist zijn om dit portaal te gebruiken.",
  "I understand that key actions may be logged for security and audit. I will keep my account credentials secure and follow applicable security procedures.": "Ik begrijp dat belangrijke acties kunnen worden gelogd voor beveiliging en audit. Ik zal mijn accountgegevens veilig houden en toepasselijke beveiligingsprocedures volgen.",
  "I understand that the Professional Portal is used to deliver occupational health services and related workflows on behalf of {organization}.": "Ik begrijp dat het Professioneel Portaal wordt gebruikt om arbodiensten en gerelateerde workflows te leveren namens {organization}.",
  "I understand that the portal may contain confidential information, including health-related data, and that access is restricted to authorized professionals based on role and assignment.": "Ik begrijp dat het portaal vertrouwelijke informatie kan bevatten, inclusief gezondheidsgerelateerde gegevens, en dat toegang beperkt is tot geautoriseerde professionals op basis van rol en toewijzing.",
  "I will record and upload only information that is necessary for service delivery and compliant case handling, in line with data minimization principles.": "Ik zal alleen informatie registreren en uploaden die noodzakelijk is voor dienstverlening en conforme dossierbehandeling, in overeenstemming met principes van gegevensminimalisatie.",
  "I will use the portal only for authorized professional purposes. I will not attempt to access data outside my permissions, share data in unauthorized ways, or otherwise misuse the system.": "Ik zal het portaal alleen gebruiken voor geautoriseerde professionele doeleinden. Ik zal niet proberen toegang te krijgen tot gegevens buiten mijn machtigingen, gegevens op ongeautoriseerde manieren delen, of anderszins het systeem misbruiken.",
  "Key rules at a glance": "Belangrijkste regels in één oogopslag",
  "Key topics include: purposes and legal bases, categories of data, recipients, retention, security measures, and rights.": "Belangrijke onderwerpen zijn: doeleinden en rechtsgrondslagen, categorieën van gegevens, ontvangers, bewaartermijnen, beveiligingsmaatregelen en rechten.",
  "Please confirm the statements below to understand your responsibilities for secure and compliant use of the Professional Portal provided by {organization}.": "Bevestig de onderstaande verklaringen om uw verantwoordelijkheden te begrijpen voor veilig en compliant gebruik van het Professioneel Portaal van {organization}.",
  "Please review the Privacy Policy of {organization} to understand how personal data is collected, used, shared, and protected.": "Bekijk het Privacybeleid van {organization} om te begrijpen hoe persoonlijke gegevens worden verzameld, gebruikt, gedeeld en beschermd.",
  "Please review the Terms & Conditions of {organization}, which define permitted use of the portal, confidentiality and security expectations, and service limitations.": "Bekijk de Algemene Voorwaarden van {organization}, die het toegestane gebruik van het portaal, vertrouwelijkheids- en beveiligingsverwachtingen en servicebeperkingen definiëren.",
  "Please review the updated documents and confirm your acceptance to continue using the portal.": "Bekijk de bijgewerkte documenten en bevestig uw acceptatie om het portaal te blijven gebruiken.",
  "Privacy & legal confirmations": "Privacy & juridische bevestigingen",
  "Privacy Policy Document": "Privacybeleid Document",
  "Privacy Policy accepted": "Privacybeleid geaccepteerd",
  "Professional use & confidentiality acknowledgements": "Professioneel gebruik & vertrouwelijkheidserkenningen",
  "Professional use & confidentiality acknowledgements confirmed": "Professioneel gebruik & vertrouwelijkheidserkenningen bevestigd",
  "Purpose and scope": "Doel en reikwijdte",
  "Required acknowledgements": "Vereiste erkenningen",
  "Required service emails": "Vereiste service-e-mails",
  "Security, credentials and logging": "Beveiliging, inloggegevens en logging",
  "Sign Out": "Uitloggen",
  "Something went wrong. Please try again.": "Er is iets misgegaan. Probeer het opnieuw.",
  "Step {current} of {total}": "Stap {current} van {total}",
  "Steps": "Stappen",
  "Summary of Changes": "Samenvatting van wijzigingen",
  "Terms & Conditions Document": "Algemene Voorwaarden Document",
  "Terms & Conditions accepted": "Algemene Voorwaarden geaccepteerd",
  "These acknowledgements ensure secure and compliant use of the Professional Portal.": "Deze erkenningen waarborgen veilig en compliant gebruik van het Professioneel Portaal.",
  "This document explains how personal data is collected, used, stored, and protected in accordance with GDPR/AVG regulations.": "Dit document legt uit hoe persoonlijke gegevens worden verzameld, gebruikt, opgeslagen en beschermd in overeenstemming met de AVG-regelgeving.",
  "This document outlines the rules for using the Professional Portal, your responsibilities, and service terms.": "Dit document beschrijft de regels voor het gebruik van het Professioneel Portaal, uw verantwoordelijkheden en servicevoorwaarden.",
  "This portal is technically provided by InCTRL, acting as a data processor on behalf of {organization}.": "Dit portaal wordt technisch geleverd door InCTRL, handelend als verwerker namens {organization}.",
  "Uncheck all": "Alles uitvinken",
  "Use the portal only for authorized professional purposes": "Gebruik het portaal alleen voor geautoriseerde professionele doeleinden",
  "View Privacy Policy": "Privacybeleid bekijken",
  "View Terms & Conditions": "Algemene Voorwaarden bekijken",
  "Without email communication, the Professional Portal cannot function properly.": "Zonder e-mailcommunicatie kan het Professioneel Portaal niet goed functioneren.",
  "You can review the accepted documents and essential communication details later in your profile.": "U kunt de geaccepteerde documenten en essentiële communicatiegegevens later in uw profiel bekijken.",
  "You have successfully completed the required confirmations.": "U heeft de vereiste bevestigingen succesvol voltooid.",
  "Your account is linked to {organization}. Before you can access the Professional Portal, please review and confirm the items below. This supports compliant handling of confidential information and secure use of the portal.": "Uw account is gekoppeld aan {organization}. Voordat u toegang krijgt tot het Professioneel Portaal, bekijkt en bevestigt u de onderstaande punten. Dit ondersteunt de correcte omgang met vertrouwelijke informatie en veilig gebruik van het portaal.",
  "Acknowledgements": "Erkenningen",
  "Terms": "Voorwaarden",
  "Complete": "Voltooid",
  "We couldn't load the Privacy Policy.": "We konden het privacybeleid niet laden.",
  "We couldn't load the Terms & Conditions.": "We konden de algemene voorwaarden niet laden.",
  "Support": "Ondersteuning",
  "New ticket": "Nieuw ticket",
  "Subject": "Onderwerp",
  "Description": "Omschrijving",
  "Attachments": "Bijlagen",
  "Add files": "Bestanden toevoegen",
  "Reply": "Antwoord",
  "Send": "Verzenden",
  "You": "U",
  "Support team": "Supportteam",
  "No tickets yet": "Nog geen tickets",
  "Select a ticket": "Selecteer een ticket",
  "Pending": "In afwachting",
  "In progress": "In behandeling",
  "Resolved": "Opgelost",
  "Don't include employee names or medical details.": "Vermeld geen namen van werknemers of medische gegevens.",
  "Support is unavailable right now.": "Ondersteuning is op dit moment niet beschikbaar.",
  "Up to 5 files, 10 MB each.": "Maximaal 5 bestanden van elk 10 MB.",
  "All statuses": "Alle statussen",
  "Ask your administrator to connect the support service.": "Vraag uw beheerder om de ondersteuningsdienst te koppelen.",
  "Create ticket": "Ticket aanmaken",
  "Describe the problem": "Beschrijf het probleem",
  "Discard this ticket?": "Dit ticket verwijderen?",
  "Discard your reply?": "Uw antwoord verwijderen?",
  "Enter a subject": "Vul een onderwerp in",
  "Its messages and your replies appear here.": "De berichten en uw antwoorden verschijnen hier.",
  "Keep the subject under 500 characters": "Houd het onderwerp onder de 500 tekens",
  "No replies yet": "Nog geen antwoorden",
  "Priority": "Prioriteit",
  "Remove {name}": "{name} verwijderen",
  "Reply sent": "Antwoord verzonden",
  "Search tickets…": "Tickets zoeken…",
  "Support is not configured": "Ondersteuning is niet ingesteld",
  "Ticket created": "Ticket aangemaakt",
  "Ticket not found": "Ticket niet gevonden",
  "Tickets you create appear here.": "Tickets die u aanmaakt verschijnen hier.",
  "What you wrote is not saved.": "Wat u schreef is niet opgeslagen.",
  "Write a reply": "Schrijf een antwoord",
  "You can add up to 5 files.": "U kunt maximaal 5 bestanden toevoegen.",
  "{name} is larger than 10 MB.": "{name} is groter dan 10 MB.",
  "{name} is not a supported file type.": "{name} is geen ondersteund bestandstype.",
  "Low": "Laag",
  "Medium": "Gemiddeld",
  "High": "Hoog",
  "Urgent": "Urgent",
  "Sign-in": "Inloggen",
  "Bug": "Fout",
  "Feature request": "Verzoek om functie",
  "Question": "Vraag",
  "Mark all as read": "Alles als gelezen markeren",
  "View all notifications": "Alle meldingen bekijken",
  "No notifications yet": "Nog geen meldingen",
  "Nothing unread": "Niets ongelezen",
  "Unread": "Ongelezen",
  "All": "Alle",
  "This notification has no further details.": "Deze melding heeft geen verdere details.",
  "Open related record": "Gekoppeld item openen",
  "Opens in the previous portal": "Opent in het vorige portaal",
  "You don't have access to notifications": "Je hebt geen toegang tot meldingen",
  "Search notifications…": "Zoek meldingen…",
  "Select a notification": "Selecteer een melding",
  "Notification not found": "Melding niet gevonden",
  "Someone": "Iemand",
  "the subject": "de betrokkene",
  "Current absences": "Actueel verzuim",
  "Everyone absent today across your organisations.": "Iedereen die vandaag afwezig is binnen je organisaties.",
  "Absences in the chosen period, this calendar year by default.": "Verzuim in de gekozen periode, standaard dit kalenderjaar.",
  "Search by name or employer…": "Zoek op naam of werkgever…",
  "No one is absent right now": "Op dit moment is niemand afwezig",
  "No absences in this period": "Geen verzuim in deze periode",
  "You don't have access to current absences": "Je hebt geen toegang tot actueel verzuim",
  "History": "Historie",
  "Percentage": "Percentage",
  "Since": "Sinds",
  "Days this year": "Dagen dit jaar",
  "Days in period": "Dagen in periode",
  "Leave empty for this calendar year.": "Leeg laten voor dit kalenderjaar.",
  "Choose a division first": "Kies eerst een divisie",
  "The end date must be on or after the start date": "De einddatum moet op of na de begindatum liggen",
  "Medical": "Medisch",
  "Training": "Training",
  "Review": "Beoordeling",
  "Message": "Bericht",
  "Change": "Wijziging",
  "Any type": "Elk type",
  "Events across your scope appear here.": "Gebeurtenissen binnen uw bereik verschijnen hier.",
  "Date": "Datum",
  "Select a person": "Selecteer een persoon",
  "Choose a department first": "Kies eerst een afdeling",
  "Search persons…": "Zoek personen…",
  "Search the timeline…": "Zoek in de tijdlijn…",
  "Every event across your scope, newest first.": "Elke gebeurtenis binnen uw bereik, nieuwste eerst.",
  "You don't have access to the timeline": "U heeft geen toegang tot de tijdlijn",
  "The end date must be on or after the start date.": "De einddatum moet op of na de begindatum liggen.",
  "An organisation filter shows events about that organisation itself, not about the people in it.": "Een organisatiefilter toont gebeurtenissen over die organisatie zelf, niet over de mensen daarin.",
  "Linked to": "Gekoppeld aan",
  "Final": "Definitief",
  "Approved": "Goedgekeurd",
  "Expired": "Verlopen",
  "Any status": "Elke status",
  "Awaiting my signature": "Wacht op mijn handtekening",
  "Every document across your scope, newest first.": "Elk document binnen uw bereik, nieuwste eerst.",
  "Matches document names and their text.": "Zoekt in documentnamen en hun tekst.",
  "Search documents…": "Zoek documenten…",
  "Documents you may see appear here.": "Documenten die u mag zien verschijnen hier.",
  "You don't have access to documents": "U heeft geen toegang tot documenten",
  "Messages": "Berichten",
  "Edited": "Bewerkt",
  "Message deleted": "Bericht verwijderd",
  "You don't have access to this document": "U heeft geen toegang tot dit document",
  "Internal": "Intern",
  "External": "Extern",
  "Archived": "Gearchiveerd",
  "Conversation updated": "Gesprek bijgewerkt",
  "{name} added a participant": "{name} heeft een deelnemer toegevoegd",
  "{name} removed a participant": "{name} heeft een deelnemer verwijderd",
  "{name} left the conversation": "{name} heeft het gesprek verlaten",
  "{name} renamed the conversation": "{name} heeft het gesprek hernoemd",
  "{name} archived the conversation": "{name} heeft het gesprek gearchiveerd",
  "{name} resolved the conversation": "{name} heeft het gesprek afgehandeld",
  "{names} is typing…": "{names} is aan het typen…",
  "Channel": "Kanaal",
  "All channels": "Alle kanalen",
  "Unread shows open conversations only.": "Ongelezen toont alleen open gesprekken.",
  "Messaging is being rolled out. Try again later.": "Berichten wordt uitgerold. Probeer het later opnieuw.",
  "Accept the terms first": "Accepteer eerst de voorwaarden",
  "Search topics…": "Zoek onderwerpen…",
  "No conversations yet": "Nog geen gesprekken",
  "No topic": "Geen onderwerp",
  "{count} unread": "{count} ongelezen",
  "Pick a conversation": "Kies een gesprek",
  "This conversation isn't available": "Dit gesprek is niet beschikbaar",
  "{count} participant | {count} participants": "{count} deelnemer | {count} deelnemers",
  "Authorized contact": "Gemachtigde",
  "Partner information": "Partnerinformatie",
  "Actions for {name}": "Acties voor {name}",
  "Edit details": "Gegevens bewerken",
  "File access": "Dossiertoegang",
  "Add activity": "Activiteit toevoegen",
  "Add person": "Persoon toevoegen",
  "Person added": "Persoon toegevoegd",
  "Leave it empty, or fill in every field marked *.": "Laat dit leeg, of vul elk veld met een * in.",
  "Choose a language": "Kies een taal",
  "Choose a client": "Kies een klant",
  "Choose an employer": "Kies een werkgever",
  "Choose a division": "Kies een divisie",
  "Choose a department": "Kies een afdeling",
  "Enter a contact number": "Vul een contactnummer in",
  "Choose a job title": "Kies een functie",
  "Choose a contract type": "Kies een contractvorm",
  "Enter the hours": "Vul de uren in",
  "Enter a percentage from 0 to 100": "Vul een percentage van 0 tot 100 in",
  "Start before the end date": "Begin vóór de einddatum",
  "Enter the last name": "Vul de achternaam in",
  "Use at least 2 characters": "Gebruik minstens 2 tekens",
  "Choose the date of birth": "Kies de geboortedatum",
  "Use at most 40 characters": "Gebruik maximaal 40 tekens",
  "Use at most 5000 characters": "Gebruik maximaal 5000 tekens",
  "Postal country": "Postland",
  "External key": "Externe sleutel",
  "Cost center": "Kostenplaats",
  "Nationality": "Nationaliteit",
  "Phone number": "Telefoonnummer",
  "Preferred language": "Voorkeurstaal",
  "Language": "Taal",
  "Job title": "Functie",
  "Start date": "Startdatum",
  "Hours per week": "Uren per week",
  "Part-time percentage": "Deeltijdpercentage",
  "Changes saved": "Wijzigingen opgeslagen",
  "Home phone": "Telefoon thuis",
  "Private phone": "Telefoon privé",
  "Business email": "Zakelijk e-mailadres",
  "Insurance": "Verzekering",
  "Insurance company": "Verzekeraar",
  "Policy number": "Polisnummer",
  "You don't have access to this person": "Je hebt geen toegang tot deze persoon",
  "Add employment": "Dienstverband toevoegen",
  "Edit employment": "Dienstverband bewerken",
  "Employment added": "Dienstverband toegevoegd",
  "Employment updated": "Dienstverband bijgewerkt",
  "Employment deleted": "Dienstverband verwijderd",
  "Delete employment?": "Dienstverband verwijderen?",
  "This cannot be undone.": "Dit kan niet ongedaan worden gemaakt.",
  "Choose a supervisor": "Kies een leidinggevende",
  "Choose an absence contact person": "Kies een verzuimcontactpersoon",
  "No one has opened this file yet": "Nog niemand heeft dit dossier geopend",
  "When": "Wanneer",
  "Who": "Wie",
  "Action": "Actie",
  "Activity type": "Activiteitstype",
  "No activities available": "Geen activiteiten beschikbaar",
  "Due date": "Vervaldatum",
  "Due time": "Vervaltijd",
  "Alert date": "Signaleringsdatum",
  "Duration in minutes": "Duur in minuten",
  "Activity order number": "Activiteitsordernummer",
  "This activity has no tasks.": "Deze activiteit heeft geen taken.",
  "Choose a task owner": "Kies een taakeigenaar",
  "No task owner available": "Geen taakeigenaar beschikbaar",
  "Assign activity": "Activiteit toewijzen",
  "Enter the duration in whole minutes": "Vul de duur in hele minuten in",
  "Choose a due date": "Kies een vervaldatum",
  "Choose an alert date": "Kies een signaleringsdatum",
  "Activity assigned Successfully!": "Activiteit succesvol toegewezen!",
  "Activity assigned — it will be scheduled automatically.": "Activiteit toegewezen — deze wordt automatisch ingepland.",
  "Created": "Aangemaakt",
  "Updated": "Gewijzigd",
  "Changed": "Aangepast",
  "Organisations": "Organisaties",
  "Your organisations": "Uw organisaties",
  "This organisation isn't available": "Deze organisatie is niet beschikbaar",
  "Nothing below this level": "Niets onder dit niveau",
  "Expand": "Uitklappen",
  "Collapse": "Inklappen",
  "Absent today": "Vandaag afwezig",
  "Open in organisation": "Openen in organisatie",
  "Open in Clients": "Openen in Klanten",
  "Open in Employers": "Openen in Werkgevers",
  "Open in Divisions": "Openen in Divisies",
  "Open in Departments": "Openen in Afdelingen",
  "No organisations to show": "Geen organisaties om te tonen",
  "Your access does not start at an organisation.": "Uw toegang begint niet bij een organisatie.",
  "Events recorded for this organisation appear here.": "Gebeurtenissen voor deze organisatie verschijnen hier.",
  "You don't have access to this timeline": "U heeft geen toegang tot deze tijdlijn",
  "No persons in this organisation": "Geen personen in deze organisatie",
  "Documents filed for this organisation appear here.": "Documenten van deze organisatie verschijnen hier.",
  "You don't have access to this organisation's documents": "U heeft geen toegang tot de documenten van deze organisatie",
  "You don't have access to these organisations": "U heeft geen toegang tot deze organisaties",
  "Choose an organisation to open it.": "Kies een organisatie om die te openen.",
  "Delete this message?": "Dit bericht verwijderen?",
  "Write a message…": "Schrijf een bericht…",
  "No one to mention": "Niemand om te noemen",
  "Mention": "Noemen",
  "This conversation is closed for new messages.": "Dit gesprek is gesloten voor nieuwe berichten.",
  "You follow this conversation as an observer.": "U volgt dit gesprek als waarnemer.",
  "You can't post in this conversation.": "U kunt in dit gesprek geen berichten plaatsen.",
  "This message is too long.": "Dit bericht is te lang.",
  "This message can no longer be edited.": "Dit bericht kan niet meer worden bewerkt.",
  "Your changes weren't saved. Try again.": "Uw wijzigingen zijn niet opgeslagen. Probeer het opnieuw.",
  "Couldn't delete this message.": "Het bericht kon niet worden verwijderd.",
  "Your message wasn't sent. Try again.": "Uw bericht is niet verzonden. Probeer het opnieuw.",
  "The message is replaced by “Message deleted” for everyone.": "Het bericht wordt voor iedereen vervangen door “Bericht verwijderd”.",
  "Discard your message?": "Uw bericht weggooien?",
  "Employer contacts can read this conversation. Don't include medical details.": "Contactpersonen van de werkgever kunnen dit gesprek lezen. Vermeld geen medische gegevens.",
  "About": "Over",
  "Add participant": "Deelnemer toevoegen",
  "Archive": "Archiveren",
  "Archive conversation?": "Gesprek archiveren?",
  "Discard this conversation?": "Dit gesprek weggooien?",
  "First message (optional)": "Eerste bericht (optioneel)",
  "Leave conversation": "Gesprek verlaten",
  "Leave this conversation?": "Dit gesprek verlaten?",
  "Left": "Vertrokken",
  "Member": "Lid",
  "New conversation": "Nieuw gesprek",
  "Observer": "Waarnemer",
  "Owner": "Eigenaar",
  "Participants": "Deelnemers",
  "Pick who this conversation is about first": "Kies eerst over wie dit gesprek gaat",
  "Remove {name}?": "{name} verwijderen?",
  "Rename": "Hernoemen",
  "Reopen": "Heropenen",
  "Resolve": "Afhandelen",
  "Resolve conversation?": "Gesprek afhandelen?",
  "Search participants…": "Zoek deelnemers…",
  "Search people…": "Zoek personen…",
  "Start conversation": "Gesprek starten",
  "The conversation couldn't be created. Try again.": "Het gesprek kon niet worden gestart. Probeer het opnieuw.",
  "The conversation couldn't be renamed. Try again.": "Het gesprek kon niet worden hernoemd. Probeer het opnieuw.",
  "The conversation leaves everyone's open list. You can find it under Archived.": "Het gesprek verdwijnt uit ieders open lijst. U vindt het terug onder Gearchiveerd.",
  "The conversation leaves everyone's open list. You can find it under Resolved.": "Het gesprek verdwijnt uit ieders open lijst. U vindt het terug onder Opgelost.",
  "They lose access to this conversation.": "Zij verliezen de toegang tot dit gesprek.",
  "Topic": "Onderwerp",
  "You can't change this conversation.": "U kunt dit gesprek niet wijzigen.",
  "You lose access to it and it leaves your inbox.": "U verliest de toegang en het verdwijnt uit uw inbox.",
  "Couldn't update the conversation. Try again.": "Het gesprek kon niet worden bijgewerkt. Probeer het opnieuw.",
  "This organisation's action list isn't available": "De actielijst van deze organisatie is niet beschikbaar",
  "No open items for this organisation": "Geen open items voor deze organisatie",
  "Open in Action list": "Openen in actielijst",
  "{count} document couldn't be attached | {count} documents couldn't be attached": "{count} document kon niet worden bijgevoegd | {count} documenten konden niet worden bijgevoegd",
  "Attach documents": "Documenten bijvoegen",
  "Attach ({count})": "Bijvoegen ({count})",
  "Maximum 10 documents": "Maximaal 10 documenten",
  "Search a document…": "Zoek een document…",
  "No documents found": "Geen documenten gevonden",
  "You don't have access to these documents": "Je hebt geen toegang tot deze documenten",
  "Attached documents": "Bijgevoegde documenten",
  "Choose up to 10 documents to send with your message": "Kies maximaal 10 documenten om met je bericht mee te sturen",
  "No appointments in this period": "Geen afspraken in deze periode",
  "Range": "Periode",
  "Up to 42 days are shown": "Er worden maximaal 42 dagen getoond",
  "{hours}h {minutes}m": "{hours}u {minutes}m",
  "{minutes}m": "{minutes}m",
  "Planned": "Gepland",
  "No appointments with this status": "Geen afspraken met deze status",
  "The end date is before the start date, so one day is shown": "De einddatum ligt voor de begindatum, dus er wordt één dag getoond",
  "Could not save the colour.": "De kleur kon niet worden opgeslagen.",
  "Agenda settings": "Agenda-instellingen",
  "Time scale": "Tijdschaal",
  "10 minutes": "10 minuten",
  "5 minutes": "5 minuten",
  "Status colours": "Statuskleuren",
  "Reset": "Reset",
  "Recurring": "Terugkerend",
  "Open dossier": "Dossier openen",
  "This week": "Deze week",
  "List view": "Lijstweergave",
  "Print": "Afdrukken",
  "Blocked": "Geblokkeerd",
  "Blocked · {time}": "Geblokkeerd · {time}",
  "Blocked · all day": "Geblokkeerd · hele dag",
  "Export": "Exporteren",
  "Export PDF": "PDF exporteren",
  "Export Excel": "Excel exporteren",
  "Export CSV": "CSV exporteren",
  "Export .ics": ".ics exporteren",
  "Export to calendar": "Naar agenda exporteren",
  "Export failed": "Exporteren mislukt",
  "Could not download .ics file": "Kon het .ics-bestand niet downloaden",
  "Select all ({selected}/{total})": "Alles selecteren ({selected}/{total})",
  "Cancel selected appointments?": "Geselecteerde afspraken annuleren?",
  "This cancels {count} appointment. | This cancels {count} appointments.": "Hiermee wordt {count} afspraak geannuleerd. | Hiermee worden {count} afspraken geannuleerd.",
  "Cancel appointments": "Afspraken annuleren",
  "Keep them": "Behouden",
  "Reason (required)": "Reden (verplicht)",
  "Why are these being cancelled?": "Waarom worden deze geannuleerd?",
  "{count} done, {failed} failed": "{count} gelukt, {failed} mislukt",
  "Bulk cancel is not available": "Bulkannulering is niet beschikbaar",
  "Bulk action failed": "Bulkactie mislukt",
  "Select {name}": "{name} selecteren",
  "Select appointment": "Afspraak selecteren",
  "No appointments for recovered persons": "Geen afspraken voor herstelde personen",
  "Me": "Ik",
  "Taken": "Bezet",
  "Outside availability": "Buiten beschikbaarheid",
  "Repeat": "Herhalen",
  "Never": "Nooit",
  "Daily": "Dagelijks",
  "Weekly": "Wekelijks",
  "Monthly": "Maandelijks",
  "Yearly": "Jaarlijks",
  "Repeat ends": "Herhaling eindigt",
  "A number of times": "Een aantal keer",
  "Until a date": "Tot een datum",
  "Number of times": "Aantal keer",
  "Repeat until": "Herhalen tot",
  "The professionals for this slot could not be loaded.": "De professionals voor dit tijdslot konden niet worden geladen.",
  "Recurring events moved.": "Terugkerende afspraken verplaatst.",
  "Move recurring event?": "Terugkerende afspraak verplaatsen?",
  "The event you moved takes the new day. The others keep their own day and take the new time.": "De verplaatste afspraak krijgt de nieuwe dag. De andere houden hun eigen dag en krijgen de nieuwe tijd.",
  "Move": "Verplaatsen",
  "Availabilities": "Beschikbaarheden",
  "Calendars": "Agenda's",
  "Search calendars…": "Agenda's zoeken…",
  "No calendars to manage": "Geen agenda's om te beheren",
  "Calendars you manage appear here.": "Agenda's die u beheert verschijnen hier.",
  "You don't have access to availabilities": "U heeft geen toegang tot beschikbaarheden",
  "Choose a calendar": "Kies een agenda",
  "A colleague's availability appears here.": "De beschikbaarheid van een collega verschijnt hier.",
  "This calendar isn't available": "Deze agenda is niet beschikbaar",
  "Types": "Soorten",
  "Availability added": "Beschikbaarheid toegevoegd",
  "Availability saved": "Beschikbaarheid opgeslagen",
  "Availability removed": "Beschikbaarheid verwijderd",
  "This availability is no longer available": "Deze beschikbaarheid is niet meer beschikbaar",
  "We could not remove this availability.": "We konden deze beschikbaarheid niet verwijderen.",
  "Enter a title": "Vul een titel in",
  "Choose a date": "Kies een datum",
  "End after the start time": "Eindig na de begintijd",
  "Choose an end date": "Kies een einddatum",
  "End on or after the start date": "Eindig op of na de begindatum",
  "Choose at least one day": "Kies minstens één dag",
  "Choose a location": "Kies een locatie",
  "Add availability": "Beschikbaarheid toevoegen",
  "Edit availability": "Beschikbaarheid bewerken",
  "When this colleague can be booked, or is away.": "Wanneer deze collega geboekt kan worden, of afwezig is.",
  "Repeats weekly": "Herhaalt wekelijks",
  "Until": "Tot en met",
  "Start time": "Begintijd",
  "End time": "Eindtijd",
  "Location": "Locatie",
  "Save anyway?": "Toch opslaan?",
  "Save anyway": "Toch opslaan",
  "This day": "Deze dag",
  "The whole series": "De hele reeks",
  "This day and following": "Deze dag en volgende",
  "Which days do you want to remove?": "Welke dagen wilt u verwijderen?",
  "Remove this availability?": "Deze beschikbaarheid verwijderen?",
  "This time has bookings": "Er zijn afspraken in deze tijd",
  "On these days": "Op deze dagen",
  "Weekdays": "Werkdagen",
  "Weekends": "Weekend",
  "Every day": "Elke dag",
  "It is taken off this colleague’s calendar.": "Ze wordt uit de agenda van deze collega gehaald.",
  "This appointment is being edited by someone else. Please try again shortly.": "Deze afspraak wordt door iemand anders bewerkt. Probeer het zo opnieuw.",
  "This appointment was changed elsewhere. The agenda has been reloaded.": "Deze afspraak is elders gewijzigd. De agenda is opnieuw geladen.",
  "Could not open the appointment.": "De afspraak kon niet worden geopend.",
  "Appointment updated": "Afspraak bijgewerkt",
  "You can no longer edit this appointment.": "U kunt deze afspraak niet meer bewerken.",
  "The signaling date may not be after the appointment date.": "De signaleringsdatum mag niet na de afspraakdatum liggen.",
  "Edit appointment": "Afspraak bewerken",
  "Your hold on this appointment has ended. Someone else may change it now.": "Uw reservering van deze afspraak is verlopen. Iemand anders kan deze nu wijzigen.",
  "Time": "Tijd",
  "Save changes": "Wijzigingen opslaan",
  "Being edited by someone else": "Wordt door iemand anders bewerkt",
  "Edit this day": "Deze dag bewerken",
  "Which days do you want to edit?": "Welke dagen wilt u bewerken?",
  "Edit from this day": "Vanaf deze dag bewerken",
  "From {date} onwards. Earlier days stay as they are.": "Vanaf {date}. Eerdere dagen blijven zoals ze zijn.",
  "Only {date} changes. The rest of the series stays as it is.": "Alleen {date} verandert. De rest van de reeks blijft zoals hij is.",
  "Busy": "Bezet",
  "Busy · {name}": "Bezet · {name}",
  "You no longer manage {name}'s calendar": "Je beheert de agenda van {name} niet meer",
  "Up to two colleagues": "Maximaal twee collega's",
  "All rooms": "Alle kamers",
  "My calendar": "Mijn agenda",
  "No appointments at this location": "Geen afspraken op deze locatie",
  "Whose calendar": "Welke agenda",
  "Only for these clients": "Alleen voor deze klanten",
  "Choose clients": "Kies klanten",
  "Search clients": "Zoek klanten",
  "No clients to choose from": "Geen klanten om uit te kiezen",
  "Choose at least one client": "Kies minstens één klant",
  "Only for {clients}": "Alleen voor {clients}",
  "Custom colours": "Eigen kleuren",
  "Background": "Achtergrond",
  "Text": "Tekst",
  "Preview": "Voorbeeld",
  "Choose a colour": "Kies een kleur",
  "Pick a text colour that stands out from the background": "Kies een tekstkleur die afsteekt tegen de achtergrond",
  "Signed in as {name}": "Ingelogd als {name}",
  "Not you?": "Niet u?",
  "Signing out…": "Uitloggen…",
  "{client} wants to access your inCTRL account": "{client} wil toegang tot uw inCTRL-account",
  "Read your workbench, caseload and action list": "Uw werkbank, caseload en actielijst lezen",
  "Read case overviews, timelines, employments and consultation notes you may see": "Dossieroverzichten, tijdlijnen, dienstverbanden en consultnotities lezen die u mag zien",
  "Read your agenda": "Uw agenda lezen",
  "It can't change anything, download documents, or see absence records.": "Het kan niets wijzigen, geen documenten downloaden en geen verzuimgegevens zien.",
  "Access lasts {days} days. Revoke any time in Settings > Connected apps.": "Toegang geldt {days} dagen. Trek die op elk moment in via Instellingen > Gekoppelde apps.",
  "Allow access": "Toegang geven",
  "Deny": "Weigeren",
  "Approving…": "Bezig met toestaan…",
  "Accept the updated terms first": "Accepteer eerst de bijgewerkte voorwaarden",
  "inCTRL needs you to accept the updated terms before you can connect an app.": "U moet in inCTRL de bijgewerkte voorwaarden accepteren voordat u een app kunt koppelen.",
  "Open inCTRL": "inCTRL openen",
  "I've accepted, continue": "Ik heb geaccepteerd, doorgaan",
  "Terms still need accepting in inCTRL.": "De voorwaarden moeten nog worden geaccepteerd in inCTRL.",
  "Too many connected apps": "Te veel gekoppelde apps",
  "You have 20 connected apps. Revoke one in Settings first.": "U hebt 20 gekoppelde apps. Trek er eerst een in via Instellingen.",
  "Open Settings": "Instellingen openen",
  "This request expired": "Dit verzoek is verlopen",
  "Go back to {client} and connect again.": "Ga terug naar {client} en koppel opnieuw.",
  "Go back to the app you were connecting and connect again.": "Ga terug naar de app die u aan het koppelen was en koppel opnieuw.",
  "This link was already used": "Deze link is al gebruikt",
  "If the app you were connecting shows inCTRL as connected, you're done. Otherwise go back and connect again.": "Als de app die u aan het koppelen was inCTRL als gekoppeld toont, bent u klaar. Ga anders terug en koppel opnieuw.",
  "This link expired": "Deze link is verlopen",
  "Approved. Returning you to {client}…": "Toegestaan. U gaat terug naar {client}…",
  "You denied access. Returning you to {client}…": "U hebt toegang geweigerd. U gaat terug naar {client}…",
  "Continue to {client}": "Doorgaan naar {client}",
  "You can close this tab.": "U kunt dit tabblad sluiten.",
  "This connection didn't finish": "Deze koppeling is niet afgerond",
  "Go back to {client} and connect again. Nothing was connected.": "Ga terug naar {client} en koppel opnieuw. Er is niets gekoppeld.",
  "inCTRL can't be reached. Try again.": "inCTRL is niet bereikbaar. Probeer het opnieuw.",
  "Connect an AI assistant": "Een AI-assistent koppelen",
  "Request expires in {minutes} min": "Verzoek verloopt over {minutes} min",
  "Request expires in less than a minute": "Verzoek verloopt binnen een minuut",
  "1 minute left": "Nog 1 minuut",
  "Connected apps": "Gekoppelde apps",
  "AI assistants that can read your inCTRL data.": "AI-assistenten die je inCTRL-gegevens kunnen lezen.",
  "No connected apps.": "Geen gekoppelde apps.",
  "When you connect an AI assistant, it shows up here.": "Als je een AI-assistent koppelt, verschijnt die hier.",
  "Connected {date}": "Gekoppeld {date}",
  "Last used {when}": "Laatst gebruikt {when}",
  "Not used yet": "Nog niet gebruikt",
  "Expires {date}": "Verloopt {date}",
  "Revoke": "Intrekken",
  "Revoke {name}?": "{name} intrekken?",
  "It loses access right away. You can connect it again later.": "De toegang stopt meteen. Je kunt de app later opnieuw koppelen.",
  "This app was already disconnected.": "Deze app was al ontkoppeld.",
  "We could not revoke this app. Please try again.": "We konden deze app niet intrekken. Probeer het opnieuw.",
  "Find a slot": "Tijdslot zoeken",
  "Slots ranked by how well they fit, best first.": "Slots gerangschikt op hoe goed ze passen, de beste eerst.",
  "Slots": "Slots",
  "Who is it for?": "Voor wie is het?",
  "Activities from": "Activiteiten uit",
  "Select an activity": "Kies een activiteit",
  "Select a location": "Kies een locatie",
  "Not on the contract": "Niet in het contract",
  "Contract is not active": "Contract is niet actief",
  "Not available": "Niet beschikbaar",
  "Time of day": "Tijd van de dag",
  "Any time": "Elk moment",
  "Evening": "Avond",
  "Find slots": "Slots zoeken",
  "Choose who the appointment is for and what it is, then find slots.": "Kies voor wie de afspraak is en wat het is, en zoek dan slots.",
  "No available slots found. Try another time of day or activity.": "Geen beschikbare slots gevonden. Probeer een andere tijd van de dag of activiteit.",
  "Smart scheduling is not available": "Slim plannen is niet beschikbaar",
  "It may not be enabled for your organisation, or you may no longer have access to this person or organisation.": "Het staat mogelijk niet aan voor je organisatie, of je hebt geen toegang meer tot deze persoon of organisatie.",
  "This time slot is no longer available. The list has been refreshed.": "Dit tijdslot is niet meer beschikbaar. De lijst is ververst.",
  "Fit {score}": "Match {score}",
  "Fit": "Match",
  "Why this slot?": "Waarom dit slot?",
  "Continuity": "Continuïteit",
  "Adjacency": "Aansluiting",
  "Time preference": "Tijdsvoorkeur",
  "Advance notice": "Aankondigingstermijn",
  "Date urgency": "Urgentie van de datum",
  "Time band completion": "Opvulling van het dagdeel",
  "Day fill": "Dagvulling",
  "Preference match": "Overeenkomst met voorkeur",
  "Choose": "Kiezen",
  "This slot no longer has a professional for every task. Pick another slot.": "Dit slot heeft niet meer voor elke taak een professional. Kies een ander slot.",
  "Delegated": "Gedelegeerd",
  "OHP instead": "Bedrijfsarts in plaats daarvan",
  "the OHP": "de bedrijfsarts",
  "{task} is carried out by {professional} under task delegation from {ohp}.": "{task} wordt uitgevoerd door {professional} onder taakdelegatie van {ohp}.",
  "{task} is carried out by {professional}.": "{task} wordt uitgevoerd door {professional}.",
  "{delegate} holds a task delegation but {reason}.": "{delegate} heeft een taakdelegatie maar {reason}.",
  "has no availability at this time": "heeft op dit moment geen beschikbaarheid",
  "is already booked at this time": "is op dit moment al geboekt",
  "is not authorised for this person or organisation": "is niet bevoegd voor deze persoon of organisatie",
  "their task delegation is no longer valid": "de taakdelegatie is niet meer geldig",
  "is already performing another task in this slot": "voert in dit slot al een andere taak uit",
  "cannot take it": "kan het niet overnemen",
  "Confirm appointment": "Afspraak bevestigen",
  "The slot is held for you for 15 minutes.": "Het slot wordt 15 minuten voor je vastgehouden.",
  "Book appointment": "Afspraak boeken",
  "Appointment booked": "Afspraak geboekt",
  "Booked: {date} at {time} with {names}": "Geboekt: {date} om {time} met {names}",
  "Open in agenda": "Openen in agenda",
  "Find another slot": "Nog een slot zoeken",
  "Scheduling preferences": "Planningsvoorkeuren",
  "How Find a slot ranks suggestions for you.": "Hoe Tijdslot zoeken suggesties voor je rangschikt.",
  "Focus": "Focus",
  "When you prefer concentrated blocks of appointments.": "Wanneer je liefst geconcentreerde blokken afspraken hebt.",
  "No preference": "Geen voorkeur",
  "Location anchor": "Locatieanker",
  "Where appointments are placed relative to your base location.": "Waar afspraken worden gepland ten opzichte van je vaste locatie.",
  "Home base": "Thuisbasis",
  "Nearest to the person": "Dichtst bij de persoon",
  "Max daily gap (minutes)": "Maximale dagelijkse tussentijd (minuten)",
  "Total gap between appointments in a day. Lower is tighter.": "Totale tijd tussen afspraken op een dag. Lager is strakker.",
  "Travel buffer (minutes)": "Reisbuffer (minuten)",
  "Minimum time between appointments at different locations.": "Minimale tijd tussen afspraken op verschillende locaties.",
  "Save preferences": "Voorkeuren opslaan",
  "Scheduling preferences saved": "Planningsvoorkeuren opgeslagen",
  "We could not load your scheduling preferences. Please try again.": "We konden je planningsvoorkeuren niet laden. Probeer het opnieuw.",
  "We could not save your scheduling preferences. Please try again.": "We konden je planningsvoorkeuren niet opslaan. Probeer het opnieuw.",
  "Enter a whole number of minutes from 0 to 480": "Vul een heel aantal minuten in van 0 tot 480",
  "Enter a whole number of minutes from 0 to 120": "Vul een heel aantal minuten in van 0 tot 120",
  "Choose another": "Andere kiezen",
  "{name} has joined the video call": "{name} neemt deel aan het videogesprek",
  "Join": "Deelnemen",
  "The call could not be started. Try again.": "Het gesprek kon niet worden gestart. Probeer het opnieuw.",
  "The appointment could not be concluded. Try again.": "De afspraak kon niet worden afgerond. Probeer het opnieuw.",
  "Allow camera and microphone in your browser, then try again.": "Geef uw browser toegang tot camera en microfoon en probeer het opnieuw.",
  "Your camera or microphone could not be started. Check that no other app is using it, then try again.": "Uw camera of microfoon kon niet worden gestart. Controleer of geen andere app deze gebruikt en probeer het opnieuw.",
  "Could not connect to the call. Check your connection, then try again.": "Kan geen verbinding maken met het gesprek. Controleer uw verbinding en probeer het opnieuw.",
  "The video service is not available right now.": "De videodienst is nu niet beschikbaar.",
  "The call was disconnected.": "De verbinding met het gesprek is verbroken.",
  "Camera {n}": "Camera {n}",
  "Microphone {n}": "Microfoon {n}",
  "No camera or microphone was found. Connect one, then try again.": "Er is geen camera of microfoon gevonden. Sluit er een aan en probeer het opnieuw.",
  "Your camera or microphone is in use by another app. Close it, then try again.": "Uw camera of microfoon wordt door een andere app gebruikt. Sluit die app en probeer het opnieuw.",
  "The camera or microphone could not be started. Try again.": "De camera of microfoon kon niet worden gestart. Probeer het opnieuw.",
  "Check your camera and microphone": "Controleer uw camera en microfoon",
  "Camera": "Camera",
  "Microphone": "Microfoon",
  "Speak to test your microphone": "Spreek om uw microfoon te testen",
  "Excellent": "Uitstekend",
  "Good": "Goed",
  "Poor": "Zwak",
  "Lost": "Verbroken",
  "Camera off": "Camera uit",
  "Connecting…": "Verbinden…",
  "Connection lost. Trying to reconnect…": "Verbinding verbroken. Opnieuw verbinden…",
  "Share screen": "Scherm delen",
  "Leave the call": "Gesprek verlaten",
  "Conclude the appointment": "Afspraak afronden",
  "Waiting for the person to join": "Wachten tot de persoon deelneemt",
  "You’re connected. The person appears here when they join.": "U bent verbonden. De persoon verschijnt hier zodra die deelneemt.",
  "This appointment’s time window has passed": "Het tijdvenster van deze afspraak is verstreken",
  "This appointment is concluded": "Deze afspraak is afgerond",
  "This video call is not available": "Dit videogesprek is niet beschikbaar",
  "Video consult": "Videoconsult",
  "{title} with {name}": "{title} met {name}",
  "Video call with {name}": "Videogesprek met {name}",
  "Open My caseload": "Mijn caseload openen",
  "Rejoin": "Opnieuw deelnemen",
  "Back to agenda": "Terug naar agenda",
  "Leave the call?": "Gesprek verlaten?",
  "The appointment stays open. You can rejoin until you conclude it.": "De afspraak blijft open. U kunt opnieuw deelnemen tot u de afspraak afrondt.",
  "Conclude the appointment?": "Afspraak afronden?",
  "This ends the call for you and the person, and concludes the appointment. You can’t undo this.": "Hiermee eindigt het gesprek voor u en de persoon en wordt de afspraak afgerond. Dit kunt u niet ongedaan maken.",
  "Open the appointment from your agenda.": "Open de afspraak vanuit uw agenda.",
  "The person may be waiting": "De persoon wacht mogelijk al",
  "You can start the call in {count} minute | You can start the call in {count} minutes": "U kunt het gesprek over {count} minuut starten | U kunt het gesprek over {count} minuten starten",
  "The call has started.": "Het gesprek is gestart.",
  "Start the call": "Gesprek starten",
  "Rejoin the call": "Opnieuw deelnemen aan het gesprek",
  "Start video call": "Videogesprek starten",
  "Call ended": "Gesprek beëindigd",
  "It may have been removed, or you may not have access to it.": "Deze is mogelijk verwijderd, of u heeft er geen toegang toe.",
  "Back to organisations": "Terug naar organisaties"
}
